<template>
    <div>
        <card :title="titleText">
            <form>
                <div class="row">
                    <div class="form-group col-md-4">
                        <label for>Tipo de Muestra</label>
                        <v-select :options="requestTypes" v-model="requestType"
                            @input="changeRequestType(requestType.code)" :disabled="editSample || formId > 0">
                            <span slot="no-options">No se encontraron Tipos de Muestra</span>
                        </v-select>
                    </div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="form-group" style="width: 20%;"
                                v-if="requestType.code == 1">
                                <label for>Origen</label>
                                <b-form-checkbox v-model="checkedWineSample" name="check-button" switch>Muestra
                                    Enológica</b-form-checkbox>
                            </div>
                            <div class="form-group" style="width: 20%;"
                                v-if="requestType.code == 2 || requestType.code == 3">
                                <label for>Muestra</label>
                                <b-form-checkbox v-model="checkedRequireTransfer" name="check-button" switch>Requiere
                                    Trasvasije</b-form-checkbox>
                            </div>
                            <div class="form-group" style="width: 20%;" v-if="requestType.code == 2">
                                <label for>Vino</label>
                                <b-form-checkbox v-model="checkedNotRealWine" name="check-button" switch>No
                                    Real</b-form-checkbox>
                            </div>
                            <div class="form-group" style="width: 20%;" v-if="requestType.code == 2">
                                <label for>No</label>
                                <b-form-checkbox v-model="checkedNotLayout" name="check-button"
                                    switch>Maquetar</b-form-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2" v-if="requestType.code == 2">
                    <div class="col-md-4">
                        <b-form-checkbox v-model="isTechnicalRequest" name="check-button" switch
                            class="pt-know-sku-checkbox">
                            <span style="font-weight: bold; color: #28a745; font-size: 15px;">Conozco el SKU</span>
                        </b-form-checkbox>
                    </div>
                </div>
                <div class="card mt-4" v-if="requestType.code == 3 && formId == 0">
                    <div class="card">
                        <div class="card-header bg-light">
                            <div class="row">
                                <div class="col-8">
                                    <span style="font-size: 18px;">Filtro SKU</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for>Calidad</label>
                                    <v-select :options="qualities" v-model="quality" @input="filterSKU">
                                        <span slot="no-options">No se encontraron Calidades</span>
                                    </v-select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for>Marca</label>
                                    <v-select @search="onSearchBrand" :options="brands" v-model="brand"
                                        :filterable="false" @input="filterSKU">
                                        <template slot="no-options">
                                            No se encontraron Marcas
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.label }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.label }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="(requestType.code == 1 || requestType.code == 2) && checkedWineSample == true">
                </div>
                <!-- Vista Simplificada PT -->
                <div class="card mt-4" v-if="requestType.code == 2 && !isTechnicalRequest && formId == 0">
                    <div class="card-header bg-light">
                        <span style="font-size: 18px;">Filtros Producto Terminado</span>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-3">
                                <label for>Calidad</label>
                                <v-select :options="qualities" v-model="quality">
                                    <span slot="no-options">No se encontraron Calidades</span>
                                </v-select>
                            </div>
                            <div class="form-group col-md-3">
                                <label for>Marca</label>
                                <v-select :options="brands" v-model="brand" :disabled="!quality">
                                    <template slot="no-options">No se encontraron Marcas</template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">{{ option.label }}</div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">{{ option.label }}</div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="form-group col-md-3">
                                <label for>Variedad</label>
                                <v-select :options="ptVarieties" v-model="ptSimplifiedVariety"
                                    :disabled="!brand || !brand.label">
                                    <span slot="no-options">No se encontraron Variedades</span>
                                </v-select>
                            </div>
                            <div class="form-group col-md-3">
                                <label for>Zona de Venta</label>
                                <v-select :options="ptSaleZones" v-model="ptSimplifiedSaleZone"
                                    :disabled="!ptSimplifiedVariety">
                                    <span slot="no-options">No se encontraron Zonas de Venta</span>
                                </v-select>
                            </div>
                            <div class="form-group col-md-3">
                                <label for>Formato</label>
                                <v-select :options="ptFormats" v-model="ptSimplifiedFormat"
                                    :disabled="!ptSimplifiedSaleZone">
                                    <span slot="no-options">No se encontraron Formatos</span>
                                </v-select>
                            </div>
                            <div class="form-group col-md-3">
                                <label for>A&ntilde;o de Cosecha</label>
                                <div class="d-flex align-items-center flex-wrap">
                                    <input v-if="!isHistoricalOrUpcoming && !isVigente" type="number" min="1900"
                                        class="form-control pt-harvest-input" v-model="ptSimplifiedHarvest" />
                                    <input v-if="isHistoricalOrUpcoming && !isVigente" type="number" min="1900"
                                        :class="'form-control pt-harvest-input ' + (historicalOrUpcomingMessage ? 'is-invalid' : '')"
                                        v-model="historicalOrUpcomingHarvest"
                                        @input="changeHistoricalOrUpcomig('PT')" />
                                    <span v-if="isVigente" class="badge badge-success align-self-center"
                                        style="font-size: 14px;">Vigente</span>
                                    <b-form-checkbox v-model="isHistoricalOrUpcoming" name="check-button"
                                        class="mb-0 ml-2 pt-historical-checkbox" :disabled="isVigente"
                                        @change="onHistoricalToggle"
                                        switch>Hist&oacute;rica/Pr&oacute;xima</b-form-checkbox>
                                    <b-form-checkbox v-model="isVigente" name="check-vigente"
                                        class="mb-0 ml-2 pt-vigente-checkbox"
                                        @change="onVigenteToggle"
                                        switch>Vigente</b-form-checkbox>
                                </div>
                                <div v-if="isHistoricalOrUpcoming && !isVigente" class="text-danger small text-left">
                                    {{ historicalOrUpcomingMessage }}
                                </div>
                            </div>
                            <div class="form-group col-md-3 offset-md-3 d-flex align-items-end justify-content-end">
                                <button type="button" class="btn btn-primary mr-2" @click="searchPtSimplified">
                                    <i class="fas fa-search mr-1"></i> Buscar
                                </button>
                                <button type="button" class="btn btn-secondary" @click="clearPtFilters">
                                    <i class="fas fa-eraser mr-1"></i> Limpiar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0" v-if="ptSimplifiedResults.length > 0">
                        <div class="d-flex align-items-center mb-2">
                            <span class="badge badge-info" style="font-size: 14px;">
                                <i class="fas fa-list mr-1"></i> {{ ptSimplifiedResults.length }} resultado{{
                                    ptSimplifiedResults.length
                                        !== 1 ? 's' : '' }} encontrado{{ ptSimplifiedResults.length !== 1 ? 's' : '' }}
                            </span>
                        </div>
                        <div class="pt-results-table" style="max-height: 400px; overflow-y: auto;">
                            <table class="table table-striped table-hover table-bordered mb-0">
                                <thead class="thead-dark" style="position: sticky; top: 0; z-index: 1;">
                                    <tr>
                                        <th style="width: 20px;"></th>
                                        <th>SKU</th>
                                        <th>Descripci&oacute;n</th>
                                        <th>C&oacute;digo Mezcla Comercial</th>
                                        <th>Mezcla Comercial</th>
                                        <th>Calidad</th>
                                        <th>Marca</th>
                                        <th>Cosecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in ptSimplifiedResults" :key="row.cSku"
                                        :class="{ 'table-primary': selectedPtRow && selectedPtRow.cSku === row.cSku }"
                                        @click="selectPtRow(row)" style="cursor: pointer;">
                                        <td>
                                            <input type="radio"
                                                :checked="selectedPtRow && selectedPtRow.cSku === row.cSku" />
                                        </td>
                                        <td>{{ row.cSku }}</td>
                                        <td>{{ row.dSku }}</td>
                                        <td>{{ row.commercialMixCode }}</td>
                                        <td>{{ row.commercialMix }}</td>
                                        <td>{{ row.quality }}</td>
                                        <td>{{ row.brand }}</td>
                                        <td>
                                            <span v-for="harvest in row.harvests" :key="row.cSku + '-' + harvest"
                                                class="badge badge-success mr-1">
                                                {{ harvest }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-body text-center text-muted" v-else-if="ptSimplifiedSearchDone">
                        No se encontraron resultados con los filtros seleccionados
                    </div>
                </div>
                <!-- Detalle Formula y Componentes para vista simplificada -->
                <div class="card mt-2 shadow-sm" v-if="requestType.code == 2 && !isTechnicalRequest && selectedPtRow">
                    <div class="card-header bg-dark text-white">
                        <i class="fas fa-box-open mr-2"></i> SKU Seleccionado: <strong>{{ selectedPtRow.cSku }} - {{
                            selectedPtRow.dSku
                            }}</strong>
                    </div>
                    <div class="card-body">
                        <div v-if="loadingPtDetail" class="text-center py-4">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Cargando...</span>
                            </div>
                            <p class="mt-2 text-muted">Cargando detalles del SKU...</p>
                        </div>
                        <div class="row mt-4" v-if="!loadingPtDetail && detailFormula != null && detailFormula.sku">
                            <div class="form-group col-md-6">
                                <div class="table-responsive">
                                    <table id="Table-Pt-Simplified" class="table table-striped table-bordered">
                                        <tr class="thead-dark">
                                            <th>Detalles</th>
                                            <th colspan="2">
                                                <table style="margin-bottom: 0px !important" v-if="stockPt.text"
                                                    class="table table-sm table-bordered"
                                                    :class="stockPt.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                    <tr>
                                                        <th class="text-left pl-2" style="width: 15% !important;">
                                                            <i class="fas fa-cubes"></i> Stock:
                                                        </th>
                                                        <th style="width: 15% !important;" class="text-right pr-2">
                                                            {{ stockPt.text }}
                                                        </th>
                                                        <th class="text-left pl-2" style="width: 18% !important;">
                                                            <i class="fas fa-seedling"></i> Cosecha:
                                                        </th>
                                                        <th style="width: 8% !important;" class="text-right pr-2">
                                                            {{ stockPt.harvest }}
                                                        </th>
                                                        <th :class="stockPt.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                            class="text-left pl-2" style="width: 20% !important;">
                                                            <i class="fas fa-clock mr-2"></i> Actualizado:
                                                        </th>
                                                        <th class="text-right pr-2" style="width: 15% !important;">
                                                            {{ stockPt.updatedStockAtString }}
                                                        </th>
                                                    </tr>
                                                </table>
                                            </th>
                                        </tr>
                                        <tr class="thead-light">
                                            <th style="width: 30%;">Sku</th>
                                            <td>{{ detailFormula.sku }}</td>
                                        </tr>
                                        <tr class="thead-light">
                                            <th>Calidad</th>
                                            <td colspan="2">{{ detailFormula.quality }}</td>
                                        </tr>
                                        <tr class="thead-light">
                                            <th>Marca</th>
                                            <td colspan="2">{{ detailFormula.brand }}</td>
                                        </tr>
                                        <tr class="thead-light" v-if="detailFormula.commercialMixCode">
                                            <th>C&oacute;digo Mezcla Comercial</th>
                                            <td colspan="2">{{ detailFormula.commercialMixCode }}</td>
                                        </tr>
                                        <tr class="thead-light">
                                            <th>Mezcla Comercial</th>
                                            <td colspan="2">{{ detailFormula.commercialMix }}</td>
                                        </tr>
                                        <tr class="thead-light">
                                            <th>Cosecha</th>
                                            <td colspan="2">{{ detailFormula.harvest }}</td>
                                        </tr>
                                        <tr class="thead-light">
                                            <th>Valle</th>
                                            <td colspan="2">{{ detailFormula.valley }}</td>
                                        </tr>
                                        <tr class="thead-light" v-if="saleZone && saleZone.code">
                                            <th>Zona de Venta</th>
                                            <td colspan="2">{{ saleZone.label ? saleZone.label : saleZone.code }}</td>
                                        </tr>
                                        <tr class="thead-light" v-if="detailFormula.semiElaborateCode">
                                            <th>C&oacute;digo Semielaborado</th>
                                            <td colspan="2">{{ detailFormula.semiElaborateCode }}</td>
                                        </tr>
                                        <tr class="thead-light" v-if="detailFormula.semiElaborateName">
                                            <th>Nombre Semielaborado</th>
                                            <td colspan="2">{{ detailFormula.semiElaborateName }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <div class="table-responsive">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="4">Componentes Asociados
                                                    <span class="ml-4 text-light"><i>(Seleccionar
                                                            Componentes)</i></span>
                                                    <span v-if="ptFormulaNumber" class="badge badge-info ml-3"
                                                        style="font-size: 12px;">
                                                        F&oacute;rmula: {{ ptFormulaNumber }} - Cosecha: {{
                                                            ptFormulaHarvest }}
                                                    </span>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th style="width: 20px;"></th>
                                                <th style="width: 12px;">Posici&oacute;n</th>
                                                <th>Componente</th>
                                                <th>C&oacute;digo Componente</th>
                                            </tr>
                                        </thead>
                                        <tr v-for="lc in ListComponentSaleZone" :key="'simp-' + lc.c_component">
                                            <td>
                                                <input
                                                    :checked="ListSelectedComponentToEdit.includes(lc.c_component) ? true : false"
                                                    @change="ComponentList(lc)" class="checkedComponent" type="checkbox"
                                                    :id="'list-component-simp-' + lc.c_component"
                                                    :value="lc.c_component" />
                                            </td>
                                            <td>
                                                <label class="ml-4" :for="'list-component-simp-' + lc.c_component">
                                                    <span>{{ lc.componentPosition }}</span>
                                                </label>
                                            </td>
                                            <td>{{ lc.componentDescription }}</td>
                                            <td>{{ lc.c_component }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mt-4 shadow-sm"
                    v-if="(requestType.code == 2 && isTechnicalRequest) || requestType.code == 3">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label v-if="requestType.code == 2" for>SKU</label>
                                <label v-if="requestType.code == 3" for>Código</label>
                                <div v-if="requestType.code == 2 || requestType.code == 3">
                                    <v-select :options="masterItems" @input="changeSku()" :disabled="formId > 0"
                                        :filterable="false" v-model="item" @search="onSearchMasterItem">
                                        <template slot="no-options">
                                            No se encontraron registros
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.label }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.label }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                            <div v-if="requestType.code == 2" class="form-group col-md-3">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label>Año Cosecha</label>
                                        <v-select :options="saleZoneYears" v-model="year"
                                            @input="changeHarvestToSaleZone()">
                                            <span slot="no-options">No se encontraron Año Cosecha</span>
                                        </v-select>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <label>Zona de Ventas</label>
                                        <v-select :options="salesZone" v-model="saleZone"
                                            @input="changeSaleZone(saleZone)">
                                            <span slot="no-options">No se encontraron Zonas de Venta</span>
                                        </v-select>
                                    </div>

                                </div>
                            </div>
                            <div v-if="requestType.code == 2" class="form-group col-md-3">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <b-form-checkbox v-model="isHistoricalOrUpcoming" name="check-button"
                                                    :disabled="isVigente" @change="onHistoricalToggle"
                                                    switch>Con Cosecha
                                                    Histórica/Próxima</b-form-checkbox>
                                                <b-form-checkbox v-model="isVigente" name="check-vigente" class="mt-1"
                                                    @change="onVigenteToggle"
                                                    switch>Cosecha Vigente</b-form-checkbox>
                                            </div>
                                            <div class="col-md-12 mt-2">
                                                <div v-if="isHistoricalOrUpcoming && !isVigente">
                                                    <input type="number" min="1900"
                                                        :class="'form-control ' + (historicalOrUpcomingMessage ? 'is-invalid' : '')"
                                                        v-model="historicalOrUpcomingHarvest"
                                                        @input="changeHistoricalOrUpcomig('PT')" />
                                                    <div class="text-danger small text-left">{{
                                                        historicalOrUpcomingMessage }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-4"
                            v-if="(requestType.code == 2 && isTechnicalRequest) || requestType.code == 3">
                            <div class="form-group col-md-6">
                                <div class="table-responsive" v-if="detailFormula != null">
                                    <table id="Table-Pt" class="table table-striped table-bordered">
                                        <tr class="thead-dark">
                                            <th>Detalles</th>
                                            <th colspan="2">
                                                <table style="margin-bottom: 0px !important"
                                                    v-if="stockPt.text || stockGb.text"
                                                    class="table table-sm table-bordered" :class="stockPt.stock > 0 && requestType.code === 2 || stockGb.stock > 0 && requestType.code === 3 ?
                                                        'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                    <tr>
                                                        <th class="text-left pl-2" style="width: 15% !important;">
                                                            <i class="fas fa-cubes"></i>
                                                            Stock:
                                                        </th>
                                                        <th style="width: 15% !important;" class="text-right pr-2">
                                                            <span v-if="requestType.code === 2">{{ stockPt.text
                                                            }}</span>
                                                            <span v-if="requestType.code === 3">{{ stockGb.text
                                                            }}</span>
                                                        </th>
                                                        <th class="text-left pl-2" style="width: 18% !important;">
                                                            <i class="fas fa-seedling"></i>
                                                            Cosecha:
                                                        </th>
                                                        <th style="width: 8% !important;" class="text-right pr-2">
                                                            <span v-if="requestType.code === 2">{{ stockPt.harvest
                                                            }}</span>
                                                            <span v-if="requestType.code === 3">{{ stockGb.harvest
                                                            }}</span>
                                                        </th>
                                                        <th :class="stockPt.stock > 0 && requestType.code === 2 || stockGb.stock > 0 && requestType.code === 3 ? 'border-left-success' : 'border-left-danger'"
                                                            class="text-left pl-2" style="width: 20% !important;">
                                                            <i class="fas fa-clock mr-2"></i>
                                                            Actualizado:
                                                        </th>
                                                        <th class="text-right pr-2" style="width: 15% !important;">
                                                            <span v-if="requestType.code === 2">{{
                                                                stockPt.updatedStockAtString
                                                            }}</span>
                                                            <span v-if="requestType.code === 3">{{
                                                                stockGb.updatedStockAtString
                                                            }}</span>
                                                        </th>
                                                    </tr>
                                                </table>

                                            </th>
                                        </tr>
                                        <tr class="thead-light">
                                            <th v-if="requestType.code === 2" style="width: 30%;">Sku</th>
                                            <th v-if="requestType.code === 3" style="width: 30%;">Código</th>
                                            <td>
                                                <span v-if="detailFormula.sku">{{ detailFormula.sku }}</span>
                                                <span v-if="!detailFormula.sku && item">{{ item.code }}</span>
                                            </td>
                                        </tr>
                                        <tr class="thead-light">
                                            <th>Calidad</th>
                                            <td colspan="2">{{ detailFormula.quality }}</td>
                                        </tr>
                                        <tr class="thead-light">
                                            <th>Marca</th>
                                            <td colspan="2">{{ detailFormula.brand }}</td>
                                        </tr>
                                        <tr class="thead-light">
                                            <th>Código Mezcla Comercial</th>
                                            <td colspan="2">{{ detailFormula.commercialMixCode }}</td>
                                        </tr>
                                        <tr class="thead-light">
                                            <th>Mezcla Comercial</th>
                                            <td colspan="2">{{ detailFormula.commercialMix }}</td>
                                        </tr>
                                        <tr class="thead-light" v-if="requestType.code == 2">
                                            <th>Cosecha</th>
                                            <td colspan="2">{{ detailFormula.harvest }}</td>
                                        </tr>
                                        <tr class="thead-light">
                                            <th>Valle</th>
                                            <td colspan="2">{{ detailFormula.valley }}</td>
                                        </tr>
                                        <tr class="thead-light" v-if="requestType.code == 2">
                                            <th>Código Semielaborado</th>
                                            <td colspan="2">{{ detailFormula.semiElaborateCode }}</td>
                                        </tr>
                                        <tr class="thead-light" v-if="requestType.code == 2">
                                            <th>Nombre Semielaborado</th>
                                            <td colspan="2">{{ detailFormula.semiElaborateName }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div
                                    v-if="(detailFormula.sku != null || detailFormula.otherSemiElaborateCode) && requestType.code == 2">
                                    <table class="table table-striped table-bordered">
                                        <tr class="thead-dark" v-if="stockOtherGb.text && requestType.code === 2">
                                            <th>Stock</th>
                                            <th>
                                                <table style="margin-bottom: 0px !important"
                                                    class="table table-sm table-bordered"
                                                    :class="stockOtherGb.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                    <tr>
                                                        <th class="text-left pl-2" style="width: 15% !important;">
                                                            <i class="fas fa-cubes"></i>
                                                            Stock:
                                                        </th>
                                                        <th style="width: 15% !important;" class="text-right pr-2">
                                                            <span>{{ stockOtherGb.text }}</span>
                                                        </th>
                                                        <th class="text-left pl-2" style="width: 18% !important;">
                                                            <i class="fas fa-seedling"></i>
                                                            Cosecha:
                                                        </th>
                                                        <th style="width: 8% !important;" class="text-right pr-2">
                                                            <span>{{ stockOtherGb.harvest }}</span>
                                                        </th>
                                                        <th :class="stockOtherGb.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                            class="text-left pl-2" style="width: 20% !important;">
                                                            <i class="fas fa-clock mr-2"></i>
                                                            Actualizado:
                                                        </th>
                                                        <th class="text-right pr-2" style="width: 15% !important;">
                                                            <span>{{ stockOtherGb.updatedStockAtString }}</span>
                                                        </th>
                                                    </tr>
                                                </table>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="thead-light" style="width: 30%">Otro Semielaborado</th>
                                            <td>
                                                <div class="d-flex align-items-center">
                                                    <div style="flex: 1;">
                                                        <span v-if="detailFormula.otherSemiElaborateCode">{{
                                                            detailFormula.otherSemiElaborateCode }} - {{
                                                                detailFormula.otherSemiElaborateName }}</span>
                                                        <v-select :options="semiElaboareList"
                                                            v-model="otherSemiElaborate" :filterable="false"
                                                            @search="onSearchOtherSemiElaborate"
                                                            @input="changeHistoricalOrUpcomig('otherGb', otherSemiElaborate.code)">
                                                            <span slot="no-options">No se encontraron otros
                                                                Semielaborados</span>
                                                        </v-select>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <div class="table-responsive">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="4">Componentes Asociados
                                                    <span v-if="requestType.code != 3"
                                                        class="ml-4 text-light"><i>(Seleccionar
                                                            Componentes)</i></span>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th v-if="requestType.code != 3" style="width: 20px;"></th>
                                                <th v-if="requestType.code === 2" style="width: 12px;">Posición</th>
                                                <th>Componente</th>
                                                <th>Código Componente</th>
                                            </tr>
                                        </thead>
                                        <tr v-for="lc in ListComponentSaleZone" :key="lc.id">
                                            <td v-if="requestType.code != 3">
                                                <input
                                                    :checked="ListSelectedComponentToEdit.includes(lc.c_component) ? true : false"
                                                    @change="ComponentList(lc)" class="checkedComponent" type="checkbox"
                                                    :id="'list-component-' + lc.c_component" :value="lc.c_component" />
                                            </td>
                                            <td v-if="requestType.code === 2">
                                                <label class="ml-4" :for="'list-component-' + lc.c_component">
                                                    <span>{{ lc.componentPosition }}</span>
                                                </label>
                                            </td>
                                            <td>
                                                {{ lc.componentDescription }}
                                            </td>
                                            <td>
                                                {{ lc.c_component }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="requestType.code == 3">
                    <div class="card mt-2 shadow-sm">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-9">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label for>Botella</label>
                                            <div class="d-flex align-items-center">
                                                <div style="flex: 1;">
                                                    <v-select :options="supplyBottles" :disabled="disabledBottleGB"
                                                        :filterable="false" v-model="bottle" @search="onSearchBottle"
                                                        @input="showStock('supply', 'bottle', bottle.code)">
                                                        <template slot="no-options">
                                                            No se encontraron registros
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row" v-if="bottle && stockBottle.text">
                                                <div class="col-md-12">
                                                    <table class="table table-sm table-bordered"
                                                        :class="stockBottle.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                        <tr>
                                                            <th class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-cubes"></i>
                                                                Stock:
                                                            </th>
                                                            <th style="width: 30% !important" class="text-right pr-2">
                                                                {{ stockBottle.text }}
                                                            </th>
                                                            <th :class="stockBottle.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                                class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-clock mr-2"></i>
                                                                Actualizado:
                                                            </th>
                                                            <th class="text-right pr-2" style="width: 30% !important">
                                                                {{ stockBottle.updatedStockAtString }}
                                                            </th>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for>Tapa</label>
                                            <div class="d-flex align-items-center">
                                                <div style="flex: 1;">
                                                    <v-select :options="supplyCappingInputs"
                                                        :disabled="disabledCappingGB" :filterable="false"
                                                        v-model="capping" @search="onSearchCapping"
                                                        @input="showStock('supply', 'capping', capping.code)">
                                                        <template slot="no-options">
                                                            No se encontraron registros
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row" v-if="capping && stockCapping.text">
                                                <div class="col-md-12">
                                                    <table class="table table-sm table-bordered"
                                                        :class="stockCapping.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                        <tr>
                                                            <th class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-cubes"></i>
                                                                Stock:
                                                            </th>
                                                            <th style="width: 30% !important" class="text-right pr-2">
                                                                {{ stockCapping.text }}
                                                            </th>
                                                            <th :class="stockCapping.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                                class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-clock mr-2"></i>
                                                                Actualizado:
                                                            </th>
                                                            <th class="text-right pr-2" style="width: 30% !important">
                                                                {{ stockCapping.updatedStockAtString }}
                                                            </th>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label for>Etiqueta</label>
                                            <div class="d-flex align-items-center">
                                                <div style="flex: 1;">
                                                    <v-select :options="supplyLabels" :filterable="false"
                                                        v-model="label" @search="onSearchLabel"
                                                        @input="showStock('supply', 'label', label.code)">
                                                        <template slot="no-options">
                                                            No se encontraron registros
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row" v-if="label && stockLabel.text">
                                                <div class="col-md-12">
                                                    <table class="table table-sm table-bordered"
                                                        :class="stockLabel.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                        <tr>
                                                            <th class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-cubes"></i>
                                                                Stock:
                                                            </th>
                                                            <th style="width: 30% !important" class="text-right pr-2">
                                                                {{ stockLabel.text }}
                                                            </th>
                                                            <th :class="stockLabel.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                                class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-clock mr-2"></i>
                                                                Actualizado:
                                                            </th>
                                                            <th class="text-right pr-2" style="width: 30% !important">
                                                                {{ stockLabel.updatedStockAtString }}
                                                            </th>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for>Contraetiqueta</label>
                                            <div class="d-flex align-items-center">
                                                <div style="flex: 1;">
                                                    <v-select :options="supplyBackLabels" :filterable="false"
                                                        v-model="backLabel" @search="onSearchBackLabel"
                                                        @input="showStock('supply', 'backLabel', backLabel.code)">
                                                        <template slot="no-options">
                                                            No se encontraron registros
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row" v-if="backLabel && stockBackLabel.text">
                                                <div class="col-md-12">
                                                    <table class="table table-sm table-bordered"
                                                        :class="stockBackLabel.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                        <tr>
                                                            <th class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-cubes"></i>
                                                                Stock:
                                                            </th>
                                                            <th style="width: 30% !important" class="text-right pr-2">
                                                                {{ stockBackLabel.text }}
                                                            </th>
                                                            <th :class="stockBackLabel.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                                class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-clock mr-2"></i>
                                                                Actualizado:
                                                            </th>
                                                            <th class="text-right pr-2" style="width: 30% !important">
                                                                {{ stockBackLabel.updatedStockAtString }}
                                                            </th>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label for>Caja</label>
                                            <div class="d-flex align-items-center">
                                                <div style="flex: 1;">
                                                    <v-select :options="supplyBoxes" :filterable="false"
                                                        :disabled="disabledBoxGB" v-model="box" @search="onSearchBox"
                                                        @input="showStock('supply', 'box', box.code)">
                                                        <template slot="no-options">
                                                            No se encontraron registros
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row" v-if="box && stockBox.text">
                                                <div class="col-md-12">
                                                    <table class="table table-sm table-bordered"
                                                        :class="stockBox.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                        <tr>
                                                            <th class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-cubes"></i>
                                                                Stock:
                                                            </th>
                                                            <th style="width: 30% !important" class="text-right pr-2">
                                                                {{ stockBox.text }}
                                                            </th>
                                                            <th :class="stockBox.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                                class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-clock mr-2"></i>
                                                                Actualizado:
                                                            </th>
                                                            <th class="text-right pr-2" style="width: 30% !important">
                                                                {{ stockBox.updatedStockAtString }}
                                                            </th>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for>Capsula</label>
                                            <div class="d-flex align-items-center">
                                                <div style="flex: 1;">
                                                    <v-select :options="supplyCapsules" :filterable="false"
                                                        :disabled="disabledCapsuleGB" v-model="capsule"
                                                        @search="onSearchCapsule"
                                                        @input="showStock('supply', 'capsule', capsule.code)">
                                                        <template slot="no-options">
                                                            No se encontraron registros
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.label }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row" v-if="capsule && stockCapsule.text">
                                                <div class="col-md-12">
                                                    <table class="table table-sm table-bordered"
                                                        :class="stockCapsule.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                        <tr>
                                                            <th class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-cubes"></i>
                                                                Stock:
                                                            </th>
                                                            <th style="width: 30% !important" class="text-right pr-2">
                                                                {{ stockCapsule.text }}
                                                            </th>
                                                            <th :class="stockCapsule.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                                class="text-left pl-2" style="width: 20% !important;">
                                                                <i class="fas fa-clock mr-2"></i>
                                                                Actualizado:
                                                            </th>
                                                            <th class="text-right pr-2" style="width: 30% !important">
                                                                {{ stockCapsule.updatedStockAtString }}
                                                            </th>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="form-group col-md-12">
                                                    <label for>Año de Cosecha</label>
                                                    <b-form-checkbox v-model="isHistoricalOrUpcoming"
                                                        name="check-button" switch>Cosecha
                                                        Histórica/Próxima</b-form-checkbox>
                                                    <v-select class="mt-2" v-if="!isHistoricalOrUpcoming"
                                                        :options="years" v-model="year"
                                                        @input="changeHistoricalOrUpcomig('GB')" />
                                                    <input v-if="isHistoricalOrUpcoming" type="number" min="1900"
                                                        :class="'mt-2 form-control ' + (historicalOrUpcomingMessage ? 'is-invalid' : '')"
                                                        v-model="historicalOrUpcomingHarvest"
                                                        @input="changeHistoricalOrUpcomig('GB')" />
                                                    <div v-if="isHistoricalOrUpcoming"
                                                        class="text-danger small text-left">{{
                                                            historicalOrUpcomingMessage }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for>Observaciones de preparación del Vino (*)</label>
                                    <button type="button" @click="NoObservation()"
                                        class="btn btn-sm btn-primary ml-4">Sin
                                        Observaciones</button>
                                    <textarea
                                        :class="'form-control ' + (obsPreparationRemarksMessage ? 'is-invalid' : '')"
                                        v-model="preparationRemarks"></textarea>
                                    <div class="text-danger small text-left">{{ obsPreparationRemarksMessage }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="requestType.code == 1 || (formId > 0 && requestType.code == 1)">
                    <div class="card mt-2">
                        <div class="card-body">
                            <!-- Primer campo destacado: define si la muestra se arma con o sin mezcla comercial. -->
                            <div class="card mt-2 shadow-sm border-info">
                                <div class="card-header text-white" style="background-color: #17A2B8 !important;">
                                    <span style="font-size: 17px; font-weight: bold;">
                                        <i class="fas fa-flask mr-2"></i>Tipo de Armado
                                    </span>
                                </div>
                                <div class="card-body">
                                    <div class="d-flex flex-wrap align-items-center mix-mode-group">
                                        <b-form-checkbox v-model="withCommercialMix" name="check-with-mix"
                                            class="mr-5 mix-mode-switch" @change="onWithMixToggle" switch>
                                            <span class="mix-mode-label">Con Mezcla Comercial</span>
                                        </b-form-checkbox>
                                        <b-form-checkbox :checked="!withCommercialMix" name="check-without-mix"
                                            class="mix-mode-switch" @change="onWithoutMixToggle" switch>
                                            <span class="mix-mode-label">Sin Mezcla Comercial</span>
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                            <div class="card mt-2 shadow-sm">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label for>Marca</label>
                                            <b-form-checkbox v-model="isNewBrand" name="check-button" switch>Nueva
                                                Marca</b-form-checkbox>
                                            <v-select class="mt-2" v-if="!isNewBrand" @search="onSearchBrand"
                                                :options="brands" v-model="brand" :filterable="false">
                                                <template slot="no-options">
                                                    No se encontraron Marcas
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <input v-if="isNewBrand" type="text" class="mt-2 form-control"
                                                v-model="newBrand" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for>Año de Cosecha <span v-if="requestType.code == 1 && !withCommercialMix" class="text-danger">(*)</span></label>
                                            <b-form-checkbox v-model="isHistoricalOrUpcoming" name="check-button"
                                                switch>Cosecha
                                                Histórica/Próxima</b-form-checkbox>
                                            <v-select class="mt-2" v-if="!isHistoricalOrUpcoming" :options="years"
                                                v-model="year" />
                                            <input v-if="isHistoricalOrUpcoming" type="number" min="1900"
                                                :class="'mt-2 form-control ' + (historicalOrUpcomingMessage ? 'is-invalid' : '')"
                                                v-model="historicalOrUpcomingHarvest" />
                                            <div v-if="isHistoricalOrUpcoming" class="text-danger small text-left">{{
                                                historicalOrUpcomingMessage }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mt-4 shadow-sm">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label for>Calidad <span v-if="requestType.code == 1 && !withCommercialMix" class="text-danger">(*)</span></label>
                                            <v-select :options="qualities" v-model="quality"
                                                :class="(requestType.code == 1 && !withCommercialMix && !quality) ? 'is-invalid-select' : ''"
                                                @input="getCommercialMix()">
                                                <span slot="no-options">No se encontraron registros</span>
                                            </v-select>
                                            <small class="text-muted d-block mt-1">Puede buscar por el nombre.</small>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for>Valle <span v-if="requestType.code == 1 && !withCommercialMix" class="text-danger">(*)</span></label>
                                            <v-select :options="valleys" v-model="valley" @search="onSearchValleys"
                                                :class="(requestType.code == 1 && !withCommercialMix && !valley) ? 'is-invalid-select' : ''"
                                                :filterable="false" @input="getCommercialMix()">
                                                <template slot="no-options">
                                                    No se encontraron registros
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <small class="text-muted d-block mt-1">Puede buscar por el nombre.</small>
                                        </div>
                                    </div>
                                    <div class="row" v-if="withCommercialMix">
                                        <div class="form-group col-md-6">
                                            <label>Mezcla Comercial <span class="text-danger">(*)</span></label>
                                            <v-select :options="commercialMixes" v-model="commercialMix"
                                                :class="commercialMixSelectMessage ? 'is-invalid-select' : ''"
                                                @input="getDetailCommercialMix">
                                                <span slot="no-options">No se encontraron Mezclas Comerciales</span>
                                            </v-select>
                                            <div class="d-flex justify-content-between align-items-start mt-1">
                                                <small class="text-muted">Puede buscar por nombre o por código de la Mezcla Comercial.</small>
                                                <span class="text-danger small text-right ml-2">{{ commercialMixSelectMessage }}</span>
                                            </div>
                                            <small v-if="commercialMixSearched && commercialMixes.length === 0 && quality && valley"
                                                class="text-muted d-block mt-1">
                                                No se han encontrado mezclas comerciales con calidad: <strong>{{ quality }}</strong> y valle: <strong>{{ valley }}</strong>.
                                            </small>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label>Otro Semielaborado</label>
                                            <v-select :options="semiElaboareList" v-model="otherSemiElaborate"
                                                :filterable="false" @search="onSearchOtherSemiElaborate">
                                                <span slot="no-options">No se encontraron otros Semielaborados</span>
                                            </v-select>
                                            <small class="text-muted d-block mt-1">Puede buscar por nombre o por código del Semielaborado.</small>
                                        </div>
                                    </div>
                                    <!-- Sin mezcla comercial + sin composición: Variedad única obligatoria. -->
                                    <div class="row" v-if="!withCommercialMix && !checkedNewComposition">
                                        <div class="form-group col-md-6">
                                            <label>Variedad <span class="text-danger">(*)</span></label>
                                            <v-select :options="varieties" v-model="npSingleVariety"
                                                :class="!npSingleVariety ? 'is-invalid-select' : ''">
                                                <span slot="no-options">No se encontraron Variedades</span>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="row" v-if="withCommercialMix && detailCommercialMix.code">
                                        <div class="form-group col-md-12">
                                            <div class="form-group">
                                                <table class="table table-striped table-hover table-bordered mt-2">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th>Código</th>
                                                            <th>Mezcla Comercial</th>
                                                            <th>Color</th>
                                                            <th>Variedad</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{{ detailCommercialMix.code }}</td>
                                                            <td>{{ detailCommercialMix.name }}</td>
                                                            <td>{{ detailCommercialMix.color }}</td>
                                                            <td>{{ detailCommercialMix.variety }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="!withCommercialMix">
                                        <div class="form-group col-md-12">
                                            <b-form-checkbox :disabled="formId > 0" v-model="checkedNewComposition"
                                                name="check-button" switch
                                                @input="isNewComposition(checkedNewComposition)">Generar
                                                Composición</b-form-checkbox>
                                            <div v-if="checkedNewComposition">
                                                <div class="card mt-4">
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col col-md-6">
                                                                <div class="form-group">
                                                                    <label>Variedad</label>
                                                                    <v-select :options="varieties" v-model="variety"
                                                                        @input="
                                                                            changeVarietyPercent(variety, percent)
                                                                            ">
                                                                        <span slot="no-options">No se encontraron
                                                                            Variedades</span>
                                                                    </v-select>
                                                                </div>

                                                                <label>%</label>
                                                                <input type="number" class="form-control" min="0"
                                                                    max="100" v-model="percent" @input="
                                                                        changeVarietyPercent(variety, percent)
                                                                        " />
                                                                <button class="btn btn-block btn-success mt-4"
                                                                    type="button" @click="AddVariety(variety, percent)"
                                                                    :disabled="BtnAddDisabled">
                                                                    <i class="fa fa-plus"></i>
                                                                    Agregar
                                                                </button>
                                                                <div></div>
                                                            </div>
                                                            <div class="col col-md-6">
                                                                <div class="form-group">
                                                                    <label>% Mezcla Total</label>
                                                                    <span v-if="valueTotal == 100">
                                                                        <b-progress :max="max" height="2rem">
                                                                            <b-progress-bar :value="valueTotal"
                                                                                @input="changeTable()"
                                                                                variant="success">
                                                                                <strong>{{ valueTotal }}% /
                                                                                    {{ max }}%</strong>
                                                                            </b-progress-bar>
                                                                        </b-progress>
                                                                    </span>
                                                                    <span v-else>
                                                                        <b-progress :max="max" height="2rem">
                                                                            <b-progress-bar :value="valueTotal"
                                                                                @input="changeTable()"
                                                                                variant="primary">
                                                                                <strong>{{ valueTotal }}% /
                                                                                    {{ max }}%</strong>
                                                                            </b-progress-bar>
                                                                        </b-progress>
                                                                    </span>
                                                                </div>
                                                                <div class="form-group mt-4">
                                                                    <label>Variedades en la Composición</label>
                                                                    <table
                                                                        class="table table-striped table-hover table-bordered">
                                                                        <thead class="thead-dark">
                                                                            <tr>
                                                                                <th>Variedad</th>
                                                                                <th>%</th>
                                                                                <th>Opciones</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(tableVariety,
                                                                                index) of listNewComposition"
                                                                                :key="index">
                                                                                <td>{{ tableVariety.variety }}</td>
                                                                                <td>{{ tableVariety.percent }}</td>
                                                                                <td
                                                                                    style="text-align: center;  width: 30px; ">
                                                                                    <button type="button"
                                                                                        title="Eliminar Item en Mezcla"
                                                                                        class="btn btn-danger"
                                                                                        @click="deleteItemMix(index)"
                                                                                        data-toggle="tooltip"
                                                                                        data-placement="top">
                                                                                        <i class="fas fa-trash"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mt-4 shadow-sm">
                                <div class="card-body">
                                    <div class="row">
                                        <!-- Izquierda: Tapa, Cápsula y Botella apilados -->
                                        <div class="col-md-7">
                                            <div class="form-group">
                                                <label for>Tapa <span class="text-danger">(*)</span></label>
                                                <div class="d-flex align-items-center">
                                                    <div style="flex: 1;">
                                                        <v-select :options="supplyCappingInputs" :filterable="false"
                                                            :class="cappingSelectMessage ? 'is-invalid-select' : ''"
                                                            v-model="capping" @search="onSearchCapping"
                                                            @input="showStock('supply', 'capping', capping.code)">
                                                            <template slot="no-options">
                                                                No se encontraron registros
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center">
                                                                    {{ option.label }}
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center">
                                                                    {{ option.label }}
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                        <div class="d-flex justify-content-between align-items-start mt-1">
                                                            <small class="text-muted">Puede buscar por nombre o por código del material.</small>
                                                            <span class="text-danger small text-right ml-2">{{ cappingSelectMessage }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="capping && stockCapping.text">
                                                    <div class="col-md-12">
                                                        <table class="table table-sm table-bordered"
                                                            :class="stockCapping.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                            <tr>
                                                                <th class="text-left pl-2" style="width: 20% !important;">
                                                                    <i class="fas fa-cubes"></i>
                                                                    Stock:
                                                                </th>
                                                                <th style="width: 30% !important" class="text-right pr-2">
                                                                    {{ stockCapping.text }}
                                                                </th>
                                                                <th :class="stockCapping.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                                    class="text-left pl-2" style="width: 20% !important;">
                                                                    <i class="fas fa-clock mr-2"></i>
                                                                    Actualizado:
                                                                </th>
                                                                <th class="text-right pr-2" style="width: 30% !important">
                                                                    {{ stockCapping.updatedStockAtString }}
                                                                </th>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for>Capsula <span class="text-danger">(*)</span></label>
                                                <div class="d-flex align-items-center">
                                                    <div style="flex: 1;">
                                                        <v-select :options="supplyCapsules" :filterable="false"
                                                            :class="capsuleSelectMessage ? 'is-invalid-select' : ''"
                                                            v-model="capsule" @search="onSearchCapsule"
                                                            @input="showStock('supply', 'capsule', capsule.code)">
                                                            <template slot="no-options">
                                                                No se encontraron registros
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center">
                                                                    {{ option.label }}
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center">
                                                                    {{ option.label }}
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                        <div class="d-flex justify-content-between align-items-start mt-1">
                                                            <small class="text-muted">Puede buscar por nombre o por código del material.</small>
                                                            <span class="text-danger small text-right ml-2">{{ capsuleSelectMessage }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="capsule && stockCapsule.text">
                                                    <div class="col-md-12">
                                                        <table class="table table-sm table-bordered"
                                                            :class="stockCapsule.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                            <tr>
                                                                <th class="text-left pl-2" style="width: 20% !important;">
                                                                    <i class="fas fa-cubes"></i>
                                                                    Stock:
                                                                </th>
                                                                <th style="width: 30% !important" class="text-right pr-2">
                                                                    {{ stockCapsule.text }}
                                                                </th>
                                                                <th :class="stockCapsule.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                                    class="text-left pl-2" style="width: 20% !important;">
                                                                    <i class="fas fa-clock mr-2"></i>
                                                                    Actualizado:
                                                                </th>
                                                                <th class="text-right pr-2" style="width: 30% !important">
                                                                    {{ stockCapsule.updatedStockAtString }}
                                                                </th>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for>Botella <span class="text-danger">(*)</span></label>
                                                <div class="d-flex align-items-center">
                                                    <div style="flex: 1;">
                                                        <v-select :options="supplyBottles" :filterable="false"
                                                            v-model="bottle"
                                                            :class="bottleSelectMessage ? 'is-invalid-select' : ''"
                                                            @search="onSearchBottle"
                                                            @input="showStock('supply', 'bottle', bottle.code)">
                                                            <template slot="no-options">
                                                                No se encontraron registros
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center">
                                                                    {{ option.label }}
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center">
                                                                    {{ option.label }}
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                        <div class="d-flex justify-content-between align-items-start mt-1">
                                                            <small class="text-muted">Puede buscar por nombre o por código del material.</small>
                                                            <span class="text-danger small text-right ml-2">{{ bottleSelectMessage }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="bottle && stockBottle.text">
                                                    <div class="col-md-12">
                                                        <table class="table table-sm table-bordered"
                                                            :class="stockBottle.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                            <tr>
                                                                <th class="text-left pl-2" style="width: 20% !important;">
                                                                    <i class="fas fa-cubes"></i>
                                                                    Stock:
                                                                </th>
                                                                <th style="width: 30% !important" class="text-right pr-2">
                                                                    {{ stockBottle.text }}
                                                                </th>
                                                                <th :class="stockBottle.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                                    class="text-left pl-2" style="width: 20% !important;">
                                                                    <i class="fas fa-clock mr-2"></i>
                                                                    Actualizado:
                                                                </th>
                                                                <th class="text-right pr-2" style="width: 30% !important">
                                                                    {{ stockBottle.updatedStockAtString }}
                                                                </th>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Derecha: Observaciones de preparación (alto alineado a los selects) -->
                                        <div class="col-md-5 d-flex flex-column">
                                            <div class="form-group d-flex flex-column flex-grow-1">
                                                <label for>Observaciones de preparación del Vino</label>
                                                <button type="button" @click="NoObservation()"
                                                    class="btn btn-sm btn-primary align-self-start mb-2">Sin
                                                    Observaciones</button>
                                                <textarea
                                                    :class="'form-control flex-grow-1 ' + (obsPreparationRemarksMessage ? 'is-invalid' : '')"
                                                    style="min-height: 260px; resize: vertical;"
                                                    v-model="preparationRemarks"></textarea>
                                                <div class="text-danger small text-left">{{ obsPreparationRemarksMessage }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="requestType.code == 1 ||
                    requestType.code == 2 ||
                    requestType.code == 3 ||
                    formId > 0
                ">
                    <div class="card mt-2 shadow-sm">
                        <div class="card-body">
                            <div class="row">
                                <div class="form-group col-md-7">
                                    <label for>Glosa Sticker</label>
                                    <textarea style="min-height: 200px;" class="form-control"
                                        v-model="stickerGloss"></textarea>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for style="font-weight: bold; font-size: 16px;">Cantidad de botellas
                                        <span class="text-danger">(*)</span></label>
                                    <div class="d-flex align-items-start">
                                        <input type="number" min="1"
                                            :class="'form-control form-control-lg ' + (bottleMessage ? 'is-invalid' : '')"
                                            style="font-weight: bold; font-size: 50px; flex: 1;" v-model="bottles" />
                                    </div>
                                    <div class="text-danger small text-right">{{ bottleMessage }}</div>
                                    <div v-if="checkedWithTasting" class="badge badge-info mt-1">
                                        Incluye Botella adicional por Muestra con Degustación
                                    </div>
                                </div>
                                <div class="form-group col-md-2">
                                    <div v-if="requestType.code == 1 || requestType.code == 2 || requestType.code == 3"
                                        class="ml-3 mt-2"
                                        :title="bottles < 1 ? 'La cantidad de botella debe ser mayor a 0 para seleccionar Muestra Con Degustación' : ''"
                                        style="pointer-events: auto;">
                                        <label class="mb-0" style="font-weight: bold;">Muestra Con Degustación</label>
                                        <b-form-checkbox v-model="checkedWithTasting" name="check-button" switch
                                            class="tasting-switch" :disabled="bottles < 1"
                                            :style="bottles < 1 ? 'pointer-events: none;' : ''"></b-form-checkbox>
                                    </div>

                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for>Observaciones de Confección de Packaging</label>
                                    <textarea class="form-control" v-model="confectionRemarks"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group mt-4">
                    <button class="btn btn-success btn-block" @click.prevent="save" title="Guardar Nueva Muestra">
                        <i class="fa fa-save"></i>
                        {{ buttonText }}
                    </button>
                    <button v-if="formId == 0" class="btn btn-secondary btn-block" @click.prevent="resetForm">
                        <i class="fa fa-refresh"></i> Limpiar Formulario
                    </button>
                    <button v-if="formId > 0" class="btn btn-warning btn-block" @click.prevent="locationRefresh">
                        <i class="fa fa-times"></i> Cancelar Edición
                    </button>
                </div>
            </form>
        </card>
    </div>
</template>

<script>
import { Get, Post, Put } from "../../../helper/axios.js";
import $ from "jquery";
import _ from "lodash";

export default {
    props: ["id", "newComposition"],
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            years: [],
            year: "",
            requestTypes: [],
            requestTypeId: 0,
            requestType: {
                code: null,
                label: null
            },
            brands: [],
            saleZoneYears: [],
            brand: "",
            varieties: [],
            variety: "",
            // Nuevo Producto: modo con/sin mezcla comercial y variedad única (cuando no hay composición).
            withCommercialMix: true,
            npSingleVariety: null,
            commercialMixSearched: false,
            valleys: [],
            valley: "",
            qualities: [],
            quality: "",
            colors: [],
            color: "",
            stickerGloss: "",
            bottles: 0,
            formId: 0,
            sampleId: 0,
            preparationRemarks: "",
            confectionRemarks: "",
            Get,
            Post,
            Put,
            supplyBottles: [],
            supplyCappingInputs: [],
            supplyBoxes: [],
            supplyCapsules: [],
            supplyLabels: [],
            supplyBackLabels: [],
            capsule: {},
            bottle: {},
            capping: {},
            box: {},
            label: {},
            backLabel: {},
            checkedWineSample: false,
            checkedWithTasting: false,
            checkedRequireTransfer: false,
            checkedNotRealWine: false,
            checkedNewComposition: false,
            checkedNotLayout: false,
            modalTitle: "",
            listNewComposition: [],
            higherPercent: 0,
            idRequestDetail: 0,
            masterItems: [],
            semiElaboareList: [],
            item: {},
            gbSearch: {},
            detailFormula: [],
            componentFormula: [],
            salesZone: [],
            saleZone: "",
            loadingPtDetail: false,
            editSample: false,
            ListComponentSaleZone: [],
            isPt: 0,
            ListSelectedComponent: [],
            existComponent: false,
            checkedComponent: false,
            commercialMixes: [],
            commercialMix: {},
            detailCommercialMix: {},
            filterMasterItems: {
                quality: "",
                brand: "",
                isPt: "",
            },
            disabledCappingGB: false,
            disabledBottleGB: false,
            disabledBoxGB: false,
            disabledCapsuleGB: false,
            percent: 0,
            valueTotal: 0,
            max: 100,
            tableVarieties: [],
            ListItem: 1,
            BtnAddDisabled: true,
            BtnSaveDisabled: true,
            otherCode: false,
            searchCode: null,
            search: '',
            offset: 0,
            limit: 10,
            ListSelectedComponentToEdit: [],
            newBrand: '',
            isNewBrand: false,
            otherSemiElaborate: {},
            isHistoricalOrUpcoming: false,
            historicalOrUpcomingHarvest: '',
            isVigente: false,
            stock: {},
            stockPt: {},
            stockGb: {},
            stockOtherGb: {},
            stockCapping: {},
            stockCapsule: {},
            stockBottle: {},
            stockBox: {},
            stockLabel: {},
            stockBackLabel: {},
            isTechnicalRequest: false,
            ptSimplifiedResults: [],
            ptVarieties: [],
            ptSaleZones: [],
            ptSimplifiedVariety: '',
            ptSimplifiedSaleZone: '',
            ptFormats: [],
            ptSimplifiedFormat: '',
            ptSimplifiedHarvest: '',
            selectedPtRow: null,
            ptSimplifiedSearchDone: false,
            ptFormulaNumber: '',
            ptFormulaHarvest: '',
        };
    },
    watch: {
        otherCode: function () {
            if (!this.otherCode) {
                this.searchCode = null
            }
        },
        isTechnicalRequest: function () {
            this.selectedPtRow = null;
            this.ptSimplifiedResults = [];
            this.item = {};
            this.detailFormula = [];
            this.saleZone = "";
            this.year = "";
            this.salesZone = [];
            this.saleZoneYears = [];
            this.ListComponentSaleZone = [];
            this.ListSelectedComponent = [];
            this.quality = "";
            this.brand = "";
            this.brands = [];
            this.ptSimplifiedVariety = "";
            this.ptVarieties = [];
            this.ptSimplifiedSaleZone = "";
            this.ptSaleZones = [];
            this.ptSimplifiedFormat = "";
            this.ptFormats = [];
            this.ptSimplifiedHarvest = "";
            this.stockPt = {};
            this.ptSimplifiedSearchDone = false;
        },
        checkedRequireTransfer: function (newVal) {
            if (this.requestType.code == 3) {
                if (newVal) {
                    this.disabledBottleGB = false;
                    this.disabledCappingGB = false;
                    this.disabledBoxGB = false;
                    this.disabledCapsuleGB = false;
                } else {
                    // Restaurar disabled para selects que tienen componente auto-asignado
                    if (this.bottle && this.bottle.code) this.disabledBottleGB = true;
                    if (this.capping && this.capping.code) this.disabledCappingGB = true;
                    if (this.box && this.box.code) this.disabledBoxGB = true;
                    if (this.capsule && this.capsule.code) this.disabledCapsuleGB = true;
                }
            }
        },
        checkedWineSample: function (newVal) {
            if (this.requestType.code == 1 && newVal) {
                this.checkedWithTasting = true;
            }
        },
        checkedWithTasting: function (newVal) {
            if (newVal) {
                this.bottles = Number(this.bottles) + 1;
            } else {
                this.bottles = Math.max(0, Number(this.bottles) - 1);
            }
        },
        bottles: function (newVal) {
            if (Number(newVal) < 1 && this.checkedRequireTransfer) {
                this.checkedRequireTransfer = false;
            }
            if (Number(newVal) < 1 && this.checkedWithTasting) {
                this.checkedWithTasting = false;
            }
        },
        isHistoricalOrUpcoming: function () {
            if (this.requestType.code == 2 && !this.isTechnicalRequest) {
                if (this.isHistoricalOrUpcoming)
                    this.historicalOrUpcomingHarvest = this.historicalOrUpcomingHarvest || this.ptSimplifiedHarvest;
                else
                    this.ptSimplifiedHarvest = this.ptSimplifiedHarvest || this.historicalOrUpcomingHarvest;
            }
        },
        quality: function (newVal) {
            if (this.requestType.code == 2 && !this.isTechnicalRequest) {
                this.brand = "";
                this.brands = [];
                this.ptSimplifiedVariety = "";
                this.ptVarieties = [];
                this.ptSimplifiedSaleZone = "";
                this.ptSaleZones = [];
                this.ptSimplifiedFormat = "";
                this.ptFormats = [];
                if (newVal) {
                    this.getPtBrandsByQuality(newVal);
                }
            }
        },
        brand: function (newVal) {
            if (this.requestType.code == 2 && !this.isTechnicalRequest) {
                this.ptSimplifiedVariety = "";
                this.ptVarieties = [];
                this.ptSimplifiedSaleZone = "";
                this.ptSaleZones = [];
                this.ptSimplifiedFormat = "";
                this.ptFormats = [];
                if (newVal && newVal.label) {
                    this.getPtVarietiesCascade(this.quality, newVal.label);
                }
            }
        },
        ptSimplifiedVariety: function (newVal) {
            if (this.requestType.code == 2 && !this.isTechnicalRequest) {
                this.ptSimplifiedSaleZone = "";
                this.ptSaleZones = [];
                this.ptSimplifiedFormat = "";
                this.ptFormats = [];
                if (newVal) {
                    var brandLabel = this.brand && this.brand.label ? this.brand.label : '';
                    this.getPtSaleZonesCascade(this.quality, brandLabel, newVal);
                }
            }
        },
        ptSimplifiedSaleZone: function (newVal) {
            if (this.requestType.code == 2 && !this.isTechnicalRequest) {
                this.ptSimplifiedFormat = "";
                this.ptFormats = [];

                if (newVal && newVal.code) {
                    var brandLabel = this.brand && this.brand.label ? this.brand.label : '';
                    this.getPtFormatsCascade(this.quality, brandLabel, this.ptSimplifiedVariety, newVal.code);
                }
            }
        }
    },
    created() {
        this.getTypes();
        this.getVariety();
        this.getSupplies();
        this.getHarvest();
        this.getQualities();
        this.getValleys();
    },
    methods: {
        onSearch(query) {
            this.search = query
            this.offset = 0
        },
        getSupplies() {
            this.$store.commit("setLoading", true);
            // Solo se precargan las 3 categorías que usa el formulario (Botella/Tapa/Cápsula)
            // con stock. Se envían los flags para que el backend no consulte las demás.
            let data = "Size=20&OnlyWithStock=True&Bottle=True&Capping=True&Capsule=True";
            this.Get(this.apiUrl + "v1/supplies?" + data, (res) => {
                this.supplyBottles = res.data.bottles;
                this.supplyCappingInputs = res.data.cappingInputs;
                this.supplyCapsules = res.data.capsules;
                this.$store.commit("setLoading", false);
            }, () => this.$store.commit("setLoading", false));
        },
        getMasterItems() {
            this.$store.commit("setLoading", true);
            this.masterItems = [];
            let isPt = false;
            if (this.requestType.code == 2)
                isPt = true;
            let data = "Size=20&IsPt=" + isPt;
            this.Get(this.apiUrl + "v1/MasterItems/GetToSelect?" + data, (res) => {
                res.data.forEach((element) => {
                    this.masterItems.push({
                        label: element.c_sku + "  " + element.d_sku,
                        code: element.c_sku,
                        brand: element.d_family,
                        quality: element.d_sub_heading,
                    });
                });
                this.$store.commit("setLoading", false);
            });
        },
        getSemiElaborateList(commercialMixCode) {
            this.$store.commit("setLoading", true);
            this.semiElaboareList = [];
            let isPt = false;
            let data = "Size=40&IsPt=" + isPt + "&CommercialMixCode=" + commercialMixCode;
            this.Get(this.apiUrl + "v1/MasterItems/GetToSelect?" + data, (res) => {
                res.data.forEach((element) => {
                    this.semiElaboareList.push({
                        label: element.c_sku + "  " + element.d_sku,
                        code: element.c_sku,
                        brand: element.d_family,
                        quality: element.d_sub_heading,
                    });
                });
                this.$store.commit("setLoading", false);
            });

        },
        getHarvest() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/harvest", (res) => {
                this.years = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        getTypes() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/mixtypes", (res) => {
                res.data.forEach((item) => {
                    // Solo Nuevo Producto (1) y Producto Terminado (2). GB/Semielaborado (3) oculto.
                    if (item.id === 3) return;
                    this.requestTypes.push({
                        code: item.id,
                        label: item.name,
                    });
                });
                this.$store.commit("setLoading", false);
            });
        },
        getBrands() {
            this.$store.commit("setLoading", true);
            let data = "Size=10&RequestTypeId=" + this.requestType.code;
            this.Get(this.apiUrl + "v1/brands?" + data, (res) => {
                this.brands = []
                res.data.forEach((item) => {
                    this.brands.push({
                        code: item.code,
                        label: item.label,
                    });
                });
                this.$store.commit("setLoading", false);
            });
        },
        getVariety() {
            this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/varieties/`, (res) => {
                this.varieties = [];
                res.data.forEach((item) => {
                    this.varieties.push({
                        code: item.varietyCode,
                        label: item.varietyDescription,
                    });
                });
                this.$store.commit("setLoading", false);
            });
        },
        getQualities() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/qualities", (res) => {
                this.qualities = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        getPtVarieties() {
            this.Get(this.apiUrl + "v1/MasterItems/GetPtVarieties", (res) => {
                this.ptVarieties = res.data;
            });
        },
        getPtFormats() {
            this.Get(this.apiUrl + "v1/MasterItems/GetPtFormats", (res) => {
                this.ptFormats = res.data;
            });
        },
        getPtSaleZones() {
            this.Get(this.apiUrl + "v1/formulas/getAllPtSaleZones", (res) => {
                this.ptSaleZones = [];
                res.data.forEach((item) => {
                    this.ptSaleZones.push({
                        code: item.code,
                        label: item.description
                    });
                });
            });
        },
        getPtBrandsByQuality(quality) {
            this.Get(this.apiUrl + "v1/MasterItems/GetPtBrandsByQuality?quality=" + encodeURIComponent(quality), (res) => {
                this.brands = [];
                res.data.forEach((item) => {
                    this.brands.push({
                        code: item.code,
                        label: item.label,
                    });
                });
            });
        },
        getPtVarietiesCascade(quality, brand) {
            let params = "?quality=" + encodeURIComponent(quality) + "&brand=" + encodeURIComponent(brand);
            this.Get(this.apiUrl + "v1/MasterItems/GetPtVarietiesCascade" + params, (res) => {
                this.ptVarieties = res.data;
            });
        },
        getPtSaleZonesCascade(quality, brand, variety) {
            let params = "?quality=" + encodeURIComponent(quality) + "&brand=" + encodeURIComponent(brand) + "&variety=" + encodeURIComponent(variety);
            this.Get(this.apiUrl + "v1/MasterItems/GetPtSaleZonesCascade" + params, (res) => {
                this.ptSaleZones = [];
                res.data.forEach((item) => {
                    this.ptSaleZones.push({
                        code: item.code,
                        label: item.description
                    });
                });
            });
        },
        getPtFormatsCascade(quality, brand, variety, saleZone) {
            let params = "?quality=" + encodeURIComponent(quality) + "&brand=" + encodeURIComponent(brand) + "&variety=" + encodeURIComponent(variety) + "&saleZone=" + saleZone;
            this.Get(this.apiUrl + "v1/MasterItems/GetPtFormatsCascade" + params, (res) => {
                this.ptFormats = res.data;
            });
        },
        clearPtFilters() {
            this.quality = "";
            this.brand = "";
            this.brands = [];
            this.ptSimplifiedVariety = "";
            this.ptVarieties = [];
            this.ptSimplifiedSaleZone = "";
            this.ptSaleZones = [];
            this.ptSimplifiedFormat = "";
            this.ptFormats = [];
            this.ptSimplifiedHarvest = "";
            this.isHistoricalOrUpcoming = false;
            this.historicalOrUpcomingHarvest = "";
            this.isVigente = false;
            this.ptSimplifiedResults = [];
            this.selectedPtRow = null;
            this.ptSimplifiedSearchDone = false;
        },
        // "Vigente" e "Histórica/Próxima" son mutuamente excluyentes.
        onHistoricalToggle(val) {
            if (val) this.isVigente = false;
        },
        onVigenteToggle(val) {
            if (val) {
                this.isHistoricalOrUpcoming = false;
                this.historicalOrUpcomingHarvest = "";
            }
        },
        // Nuevo Producto: "Con mezcla comercial" y "Sin mezcla comercial" son mutuamente excluyentes.
        onWithMixToggle(val) {
            this.withCommercialMix = val;
            if (val) {
                // Modo Con: se limpia la composición y la variedad única.
                this.checkedNewComposition = false;
                this.npSingleVariety = null;
            } else {
                this.clearCommercialMixSelection();
            }
        },
        onWithoutMixToggle(val) {
            // El switch "Sin" refleja el inverso de withCommercialMix.
            this.withCommercialMix = !val;
            if (val) {
                this.clearCommercialMixSelection();
            } else {
                this.checkedNewComposition = false;
                this.npSingleVariety = null;
            }
        },
        clearCommercialMixSelection() {
            this.commercialMix = {};
            this.detailCommercialMix = {};
            this.otherSemiElaborate = {};
        },
        searchPtSimplified() {
            this.ptSimplifiedSearchDone = true;
            this.$store.commit("setLoading", true);
            let params = "?";
            if (this.quality)
                params += "Quality=" + this.quality + "&";
            if (this.brand && this.brand.label)
                params += "Brand=" + this.brand.label + "&";
            if (this.ptSimplifiedVariety)
                params += "Variety=" + this.ptSimplifiedVariety + "&";
            if (this.ptSimplifiedSaleZone && this.ptSimplifiedSaleZone.code)
                params += "SaleZone=" + this.ptSimplifiedSaleZone.code + "&";
            if (this.ptSimplifiedFormat)
                params += "Format=" + this.ptSimplifiedFormat + "&";
            // Con "Vigente" no se filtra por año: se toma la cosecha vigente del producto.
            if (this.ptSimplifiedHarvest && !this.isHistoricalOrUpcoming && !this.isVigente)
                params += "Harvest=" + this.ptSimplifiedHarvest + "&";

            this.Get(this.apiUrl + "v1/MasterItems/SearchPtSimplified" + params, (res) => {
                this.ptSimplifiedResults = res.data;
                this.selectedPtRow = null;
                this.$store.commit("setLoading", false);
            });
        },
        selectPtRow(row) {
            this.loadingPtDetail = true;
            this.selectedPtRow = row;
            this.item = {
                label: row.cSku + "  " + row.dSku,
                code: row.cSku,
                brand: row.brand,
                quality: row.quality
            };
            this.year = this.resolvePtSimplifiedHarvest(row);
            this.saleZone = this.resolvePtSimplifiedSaleZone(row, this.year);
            this.changeSku(row.cSku);
        },
        resolvePtSimplifiedHarvest(row) {
            if (this.ptSimplifiedHarvest && !this.isHistoricalOrUpcoming)
                return this.ptSimplifiedHarvest;
            if (!row.harvests || row.harvests.length === 0)
                return "";
            return row.harvests.slice().sort((a, b) => Number(b) - Number(a))[0];
        },
        resolvePtSimplifiedSaleZone(row, harvest) {
            if (this.ptSimplifiedSaleZone && this.ptSimplifiedSaleZone.code)
                return { code: this.ptSimplifiedSaleZone.code, label: this.ptSimplifiedSaleZone.label };
            if (!row.harvestSaleZones || !harvest)
                return "";
            const saleZone = row.harvestSaleZones
                .filter((item) => item.harvest == harvest)
                .sort((a, b) => Number(a.saleZone) - Number(b.saleZone))[0];
            if (!saleZone) return "";
            const desc = saleZone.saleZoneDescription;
            const label = desc ? saleZone.saleZone + " - " + desc : "";
            return { code: saleZone.saleZone, label: label };
        },
        getValleys() {
            this.$store.commit("setLoading", true);
            let data = "Size=20";
            this.Get(this.apiUrl + "v1/valleys?" + data, (res) => {
                this.valleys = res.data;

                this.$store.commit("setLoading", false);
            })
        },
        isNewComposition(newComposition) {
            this.valley = "";
            this.quality = "";
            this.commercialMixes = [];
            this.commercialMix = "";
            this.detailCommercialMix = {};

            if (newComposition == true) {
                this.$store.commit("setLoading", true);
                this.Get(this.apiUrl + "v1/blends", (res) => {
                    this.valleys = res.data.valleys;
                    this.$store.commit("setLoading", false);
                });
            }
        },
        getCommercialMix() {
            this.commercialMixes = [];
            this.commercialMix = "";
            this.detailCommercialMix = {};
            this.commercialMixSearched = false;
            this.$store.commit("setLoading", true);
            this.Get(
                this.apiUrl + "v1/commercialmix/" + this.quality + ";" + this.valley,
                (res) => {
                    res.data.forEach((item) => {
                        this.commercialMixes.push({
                            code: item.code,
                            label: item.code + " - " + item.name,
                        });
                    });
                    this.commercialMixSearched = true;
                    this.$store.commit("setLoading", false);
                }
            );

        },
        getDetailCommercialMix() {
            if (this.commercialMix !== null) {
                this.$store.commit("setLoading", true);
                this.Get(
                    this.apiUrl + "v1/detailscommercialmix/" + this.commercialMix?.code,
                    (res) => {
                        this.detailCommercialMix = res.data;
                        if (res.data.quality) {
                            this.quality = res.data.quality
                        }
                        if (res.data.valley) {
                            this.valley = res.data.valley
                        }
                        if (res.data.valleys) {
                            this.valleys = res.data.valleys;
                        }
                        this.getSemiElaborateList(this.commercialMix?.code);
                        this.$store.commit("setLoading", false);
                    }
                );
            }
            else {
                this.quality = '';
                this.valley = '';
                this.getQualities();
                this.getValleys();
                this.detailCommercialMix = {};
            }
        },
        showModal() {
            this.modalTitle = "Crear Composición";
            $("#commercialMixModal").modal("show");
        },
        closeModal() {
            $("#commercialMixModal").modal("hide");
            this.getVarietyName();
        },
        getVarietyName() {
            this.$store.commit("setLoading", true);
            this.higherPercent = 0;
            this.variety = "";
            for (let i = 0; i < this.listNewComposition.length; i++) {
                if (this.listNewComposition[i].percent > this.higherPercent) {
                    this.higherPercent = this.listNewComposition[i].percent;
                    this.variety = this.listNewComposition[i].variety;
                    this.$store.commit("setLoading", false);
                }
            }
        },
        save() {
            let listSelectedComponent = this.ListSelectedComponent
            let newComposition = this.checkedNewComposition
            if (!this.requestType.code && this.requestTypeId <= 0) {
                window.toastr.warning("El tipo de muestra es Requerida");
                return;
            }
            if (
                this.requestType.code == 1 &&
                this.checkedNewComposition &&
                this.valueTotal != 100
            ) {
                window.toastr.warning(
                    "Para una nueva composición, debe cumplir el 100%"
                );
                return;
            }
            if (this.bottles < 1) {
                window.toastr.warning("La cantidad de Botella debe ser mayor a 0");
                return;
            }
            if (this.requestType.code === 1) {
                if (!this.capping?.code) {
                    window.toastr.warning("La Tapa es Requerida");
                    return;
                }
                if (!this.bottle?.code) {
                    window.toastr.warning("La Botella es Requerida");
                    return;
                }
                if (!this.capsule?.code) {
                    window.toastr.warning("La Cápsula es Requerida");
                    return;
                }
                // Con mezcla comercial: la Mezcla Comercial es obligatoria.
                if (this.withCommercialMix && !(this.commercialMix && this.commercialMix.code)) {
                    window.toastr.warning("La Mezcla Comercial es Requerida");
                    return;
                }
                // Sin mezcla comercial: Variedad/Calidad/Cosecha/Valle obligatorios.
                if (!this.withCommercialMix) {
                    if (!this.quality) {
                        window.toastr.warning("La Calidad es Requerida");
                        return;
                    }
                    const harvestValue = this.isHistoricalOrUpcoming ? this.historicalOrUpcomingHarvest : this.year;
                    if (!harvestValue) {
                        window.toastr.warning("El Año de Cosecha es Requerido");
                        return;
                    }
                    if (!this.valley) {
                        window.toastr.warning("El Valle es Requerido");
                        return;
                    }
                    if (!this.checkedNewComposition && !this.npSingleVariety) {
                        window.toastr.warning("La Variedad es Requerida");
                        return;
                    }
                }
            }
            // Observaciones opcional para Nuevo Producto; se mantiene requerida solo en Guarda Botella (3).
            if (!this.preparationRemarks && this.requestType.code == 3) {
                window.toastr.warning("Observaciones de preparación del Vino es requerido");
                return;
            }
            if (this.requestType.code === 2 || this.requestType.code === 3) {
                let sku = 'El SKU';
                if (this.requestType.code === 3)
                    sku = 'El Código de Guarda Botella'
                if (!this.item?.code) {
                    window.toastr.warning(sku + " es Requerido");
                    return;
                }
                if (this.requestType.code === 2 && this.isHistoricalOrUpcoming && !this.historicalOrUpcomingHarvest) {
                    window.toastr.warning("Como está seleccionado Con Cosecha Histórica/Próxima, esta Cosecha es Requerida");
                    return;
                }
            }
            var data;
            var isPt = false;
            if (this.requestType.code == 1) {
                let brand = "";
                if (this.isNewBrand) {
                    if (this.newBrand)
                        brand = this.newBrand
                    else
                        window.toastr.warning("Como tiene seleccionado Marca Nueva, Debe Ingresarla");
                }
                if (!this.isNewBrand) {
                    if (this.brand && Object.keys(this.brand).length > 0) {
                        if (!this.brand.label)
                            brand = this.brand;
                        if (this.brand.label)
                            brand = this.brand.label
                    }
                    else {
                        brand = null;
                    }
                }
                data = {
                    RequestTypeId: this.requestType.code ? this.requestType.code : this.requestTypeId,
                    Brand: brand,
                    // Con mezcla: variedad de la mezcla. Sin mezcla y sin composición: variedad única.
                    Variety: (!this.withCommercialMix && !this.checkedNewComposition)
                        ? (this.npSingleVariety ? this.npSingleVariety.label : null)
                        : this.detailCommercialMix.variety,
                    Quality: this.quality,
                    Harvest: this.year,
                    Valley: this.valley,
                    StickerGloss: this.stickerGloss,
                    PreparationRemarks: this.preparationRemarks,
                    ConfectionRemarks: this.confectionRemarks,
                    Quantity: this.bottles,
                    CapsuleName: this.capsule.label ? this.capsule.label : null,
                    CapsuleCode: this.capsule.code ? this.capsule.code : null,
                    CappingName: this.capping.label ? this.capping.label : null,
                    CappingCode: this.capping.code ? this.capping.code : null,
                    BottleName: this.bottle.label ? this.bottle.label : null,
                    BottleCode: this.bottle.code ? this.bottle.code : null,
                    // Caja, Etiqueta y Contraetiqueta no aplican a Nuevo Producto.
                    BoxName: null,
                    BoxCode: null,
                    LabelCode: null,
                    LabelName: null,
                    BackLabelCode: null,
                    BackLabelName: null,
                    DispatchedAt: null,
                    Sku: null,
                    SaleZone: null,
                    SaleZoneCode: null,
                    WineSample: this.checkedWineSample,
                    WithTasting: this.checkedWithTasting,
                    RequireTransfer: this.checkedRequireTransfer,
                    IsNewComposition: newComposition,
                    WithCommercialMix: this.withCommercialMix,
                    // Sin mezcla comercial: no se persiste mezcla.
                    ComercialMix: this.withCommercialMix && this.detailCommercialMix.name ? this.detailCommercialMix.name : null,
                    ComercialMixCode: this.withCommercialMix && this.detailCommercialMix.code ? this.detailCommercialMix.code : null,
                    OtherSemiElaborateCode: this.withCommercialMix ? this.otherSemiElaborate.code : null,
                    IsHistoricalOrUpcoming: this.isHistoricalOrUpcoming,
                    FinalHarvest: this.isHistoricalOrUpcoming ? this.historicalOrUpcomingHarvest : this.year
                };
                isPt = false;
            } else if (this.requestType.code == 2) {
                data = {
                    RequestTypeId: this.requestType.code ? this.requestType.code : this.requestTypeId,
                    Brand: this.detailFormula.brand,
                    Variety: this.detailFormula.variety,
                    Quality: this.detailFormula.quality,
                    Harvest: this.isVigente ? "Vigente" : this.detailFormula.harvest,
                    Valley: this.detailFormula.valley,
                    StickerGloss: this.stickerGloss,
                    PreparationRemarks: null,
                    ConfectionRemarks: this.confectionRemarks,
                    Quantity: this.bottles,
                    CapsuleName: null,
                    CapsuleCode: null,
                    CappingName: null,
                    CappingCode: null,
                    BottleName: null,
                    BottleCode: null,
                    BoxName: null,
                    BoxCode: null,
                    DispatchedAt: null,
                    Sku: this.detailFormula.sku,
                    WineSample: this.checkedWineSample,
                    WithTasting: this.checkedWithTasting,
                    RequireTransfer: this.checkedRequireTransfer,
                    NotRealWine: this.checkedNotRealWine,
                    NotLayout: this.checkedNotLayout,
                    SaleZone: this.saleZone.label,
                    SaleZoneCode: this.saleZone.code.toString(),
                    ComercialMix: this.detailFormula.commercialMix,
                    ComercialMixCode: this.detailFormula.commercialMixCode,
                    SemiElaborateCode: this.detailFormula.semiElaborateCode,
                    SemiElaborateName: this.detailFormula.semiElaborateName,
                    OtherSemiElaborateCode: this.otherSemiElaborate.code,
                    IsHistoricalOrUpcoming: this.isHistoricalOrUpcoming,
                    IsVigente: this.isVigente,
                    FinalHarvest: this.isVigente ? "Vigente" : (this.isHistoricalOrUpcoming ? this.historicalOrUpcomingHarvest : this.detailFormula.harvest),
                    FinalSku: this.detailFormula.sku
                };
                isPt = true;
            } else if (this.requestType.code == 3) {
                data = {
                    RequestTypeId: this.requestType.code
                        ? this.requestType.code
                        : this.requestTypeId,
                    Brand: this.detailFormula.brand,
                    Variety: this.detailFormula.variety,
                    Quality: this.detailFormula.quality,
                    Harvest: this.year,
                    Valley: this.detailFormula.valley,
                    StickerGloss: this.stickerGloss,
                    PreparationRemarks: this.preparationRemarks ? this.preparationRemarks : null,
                    ConfectionRemarks: this.confectionRemarks,
                    Quantity: this.bottles,
                    CapsuleName: this.capsule.label ? this.capsule.label : null,
                    CapsuleCode: this.capsule.code ? this.capsule.code : null,
                    CappingName: this.capping.label ? this.capping.label : null,
                    CappingCode: this.capping.code ? this.capping.code : null,
                    BottleName: this.bottle.label ? this.bottle.label : null,
                    BottleCode: this.bottle.code ? this.bottle.code : null,
                    BoxName: this.box.label ? this.box.label : null,
                    BoxCode: this.box.code ? this.box.code : null,
                    LabelCode: this.label.code ? this.label.code : null,
                    LabelName: this.label.label ? this.label.label : null,
                    BackLabelCode: this.backLabel.code ? this.backLabel.code : null,
                    BackLabelName: this.backLabel.name ? this.backLabel.name : null,
                    DispatchedAt: null,
                    Sku: this.detailFormula.sku,
                    WineSample: this.checkedWineSample,
                    WithTasting: this.checkedWithTasting,
                    RequireTransfer: this.checkedRequireTransfer,
                    SaleZone: null,
                    SaleZoneCode: null,
                    ComercialMix: this.detailFormula.commercialMix,
                    ComercialMixCode: this.detailFormula.commercialMixCode,
                    IsHistoricalOrUpcoming: this.isHistoricalOrUpcoming,
                    FinalHarvest: this.isHistoricalOrUpcoming ? this.historicalOrUpcomingHarvest : this.year
                };
                isPt = false;
            }
            if (this.formId > 0) {
                data.requestCommercialSampleId = this.sampleId;
                this.$store.commit("setLoading", true);
                let detailId = this.formId;
                this.Put(
                    `${this.apiUrl}v1/requestsample/${this.sampleId}/details?detailId=${this.formId}`, data, () => {
                        if (isPt == true) {
                            let dataComponentList = []
                            for (let i = 0; i < listSelectedComponent.length; i++) {
                                let dataComponent = {
                                    c_sku: listSelectedComponent[i].c_component,
                                    saleZone: listSelectedComponent[i].saleZone,
                                    name: listSelectedComponent[i].d_component,
                                    RequestCommercialSampleDetailId: detailId,
                                    componentPosition: listSelectedComponent[i].componentPosition,
                                };
                                dataComponentList.push(dataComponent);
                            }
                            let componentData = {
                                id: detailId,
                                components: dataComponentList
                            }
                            this.Put(`${this.apiUrl}v1/selectedcomponents/`, componentData, () => { });
                        }
                        if (newComposition) {
                            this.Put(this.apiUrl + "v1/compositionsUpdate/" + detailId, this.listNewComposition, () => { });
                        }

                        this.$store.commit("setLoading", false);
                        this.resetForm();
                        this.$emit("updateDetails", true);
                    }
                );
            } else {
                this.Post(`${this.apiUrl}v1/requestsample/${this.id}/details`, data, (res) => {
                    this.idRequestDetail = res.data;
                    for (let i = 0; i < this.listNewComposition.length; i++) {
                        this.listNewComposition[i].RequestCommercialSampleDetailId =
                            res.data;
                        this.Post(`${this.apiUrl}v1/compositions/`, this.listNewComposition[i], () => { });
                    }
                    if (isPt == true) {
                        for (let i = 0; i < listSelectedComponent.length; i++) {
                            let data = {
                                c_sku: listSelectedComponent[i].c_component,
                                saleZone: listSelectedComponent[i].saleZone,
                                name: listSelectedComponent[i].d_component,
                                RequestCommercialSampleDetailId: res.data,
                                componentPosition: listSelectedComponent[i].componentPosition,
                            };

                            this.Post(`${this.apiUrl}v1/selectedcomponents/`, data, () => { });
                            //this.Post(`${this.apiUrl}v1/selectedcomponents/`, data,  () => {});
                        }
                    }
                    isPt = false;
                    this.listNewComposition = [];
                    window.toastr.success("La muestra ha sido creada correctamente");
                    this.otherCode = false;
                    this.searchCode = null;
                    this.$emit("updateDetails", true);
                }
                );
                this.resetForm();
            }
            this.resetForm();
        },
        async clone(item) { //TO UPDATE
            this.getSupplies()
            this.requestTypeId = item.requestTypeId;
            this.checkedWithTasting = item.withTasting;
            this.isHistoricalOrUpcoming = item.isHistoricalOrUpcoming;
            if (item.isHistoricalOrUpcoming)
                this.historicalOrUpcomingHarvest = item.finalHarvest;
            this.isVigente = item.isVigente;
            this.requestType = {
                code: item.requestType.id,
                label: item.requestType.name,
            };

            if (item.editId > 0) {
                this.sampleId = item.requestCommercialSampleId;
                this.formId = item.id;
            }
            if (item.requestTypeId == 1 || item.requestTypeId == 3) {
                this.year = item.harvest;
                this.valley = item.valley;
                if (item.capsuleCode && item.capsuleName)
                    this.capsule = { code: item.capsuleCode, label: item.capsuleName + " - " + item.capsuleCode };
                if (item.cappingCode && item.cappingName)
                    this.capping = { code: item.cappingCode, label: item.cappingName + " - " + item.cappingCode, };
                if (item.bottleName && item.bottleCode)
                    this.bottle = { code: item.bottleCode, label: item.bottleName + " - " + item.bottleCode };
                if (item.boxName && item.boxCode)
                    this.box = { code: item.boxCode, label: item.boxName + " - " + item.boxCode };
            }

            if (item.requestTypeId == 1) {

                this.getBrands();
                if (item.isNewComposition) {
                    this.listNewComposition = item.composition;
                    this.checkedNewComposition = true;
                    this.valueTotal = item.totalPercentComposition;


                }
                this.quality = item.quality;
                if (!item.isNewComposition) {
                    this.checkedNewComposition = false;
                    this.getCommercialMix();
                    if (item.comercialMix && item.comercialMixCode) {
                        this.commercialMix = { code: item.comercialMixCode, label: item.comercialMixCode + " - " + item.comercialMix, };
                        this.getSemiElaborateList(item.comercialMixCode);
                    }
                    this.detailCommercialMix.code = item.comercialMixCode;
                    this.detailCommercialMix.name = item.comercialMix
                    this.detailCommercialMix.color = item.commercialMixColor
                    this.detailCommercialMix.variety = item.variety
                }

                this.brand = item.brand;
                this.variety = item.variety;

                // Restaurar modo con/sin mezcla comercial y origen enológico del registro.
                // Usa el campo persistido; para registros antiguos (sin el flag) se deduce por la mezcla.
                this.withCommercialMix = item.withCommercialMix || !!item.comercialMixCode;
                this.checkedWineSample = item.wineSample;
                if (!this.withCommercialMix && !item.isNewComposition && item.variety) {
                    this.npSingleVariety = { code: item.variety, label: item.variety };
                }

                if (item.otherSemiElaborateCode) {
                    this.otherSemiElaborate = {
                        'code': item.otherSemiElaborateCode,
                        'label': item.otherSemiElaborateCode + ' ' + item.otherSemiElaborateName
                    }
                }

            }


            if (item.requestTypeId == 2 || item.requestTypeId == 3) {
                this.checkedRequireTransfer = item.requireTransfer;
                this.detailFormula.sku = item.sku;
                this.detailFormula.quality = item.quality;
                this.detailFormula.brand = item.brand;
                this.detailFormula.commercialMixCode = item.comercialMixCode;
                this.detailFormula.commercialMix = item.comercialMix;
                this.detailFormula.valley = item.valley;
                this.item = {
                    code: item.sku,
                    label: item.sku,
                };
                if (item.otherSemiElaborateCode) {
                    this.otherSemiElaborate = {
                        'code': item.otherSemiElaborateCode,
                        'label': item.otherSemiElaborateCode + ' ' + item.otherSemiElaborateName
                    }
                }
            }

            if (item.requestTypeId == 1 || item.requestTypeId == 3) {
                if (item.backLabelCode && item.backLabelName)
                    this.backLabel = { code: item.backLabelCode, label: item.backLabelName + " - " + item.backLabelCode }
                if (item.labelCode && item.labelName)
                    this.label = { code: item.labelCode, label: item.labelName + " - " + item.labelCode }
            }

            if (item.requestTypeId == 1 || item.requestTypeId == 2) {
                this.checkedWineSample = item.wineSample;
            }

            if (item.requestTypeId === 2) {
                this.checkedNotRealWine = item.notRealWine;
                this.checkedNotLayout = item.notLayout
            }

            if (item.requestTypeId == 2 || item.requestTypeId == 3) {
                this.ListComponentSaleZone = [];
                this.ListSelectedComponentToEdit = [];
                this.detailFormula.harvest = item.harvest;

                this.changeSku(item.sku);
                this.year = item.harvest;
                this.changeHarvestToSaleZone(item.sku);
                this.saleZone = {
                    label: item.saleZone,
                    code: item.saleZoneCode
                }
                this.changeSaleZone();
                await item.components;
                item.components.forEach((element) => {
                    this.ListSelectedComponentToEdit.push(element.sku)
                    this.ListSelectedComponent.push({
                        "d_component": element.name,
                        "c_component": element.sku,
                        "saleZone": element.saleZone,
                        "componentPosition": element.componentPosition
                    });

                    if (element.sku == this.bottle.code)
                        this.disabledBottleGB = true;
                    if (element.sku == this.capping.code)
                        this.disabledCappingGB = true;
                    if (element.sku == this.capsule.code)
                        this.disabledCappingGB = true;
                    if (element.sku == this.box.code)
                        this.disabledBoxGB = true;
                })

            }

            this.stickerGloss = item.stickerGloss;
            this.preparationRemarks = item.preparationRemarks;
            this.confectionRemarks = item.confectionRemarks;
            this.bottles = item.quantity;

        },
        resetForm() {
            this.requestTypeId = "";
            this.requestType = {};
            this.brand = {};
            this.bottle = {};
            this.box = {};
            this.capping = {};
            this.capsule = {};
            this.label = {};
            this.backLabel = {};
            this.variety = "";
            this.quality = "";
            this.year = "";
            this.valley = "";
            this.stickerGloss = "";
            this.preparationRemarks = "";
            this.confectionRemarks = "";
            this.bottles = 0;
            this.formId = 0;
            this.sampleId = 0;
            this.higherPercent = 0;
            (this.checkedRequireTransfer = false),
                (this.checkedWithTasting = false),
                (this.checkedWineSample = false),
                (this.higherPercent = 0),
                (this.idRequestDetail = 0),
                (this.formula = {}),
                (this.editSample = false),
                (this.detailFormula = []),
                (this.checkedNotRealWine = false),
                (this.checkedNotLayout = false);
            this.componentFormula = [];
            this.item = {};
            this.saleZone = "";
            this.stickerGloss = "";
            this.confectionRemarks = "";
            this.ListComponentSaleZone = [];
            (this.disabledCappingGB = false), (this.disabledBottleGB = false);
            this.disabledBoxGB = false;
            this.disabledCapsuleGB = false;
            this.detailCommercialMix = {};
            this.commercialMixes = [];
            this.commercialMix = {};
            this.checkedNewComposition = false;
            this.valueTotal = 0;
            this.ListSelectedComponentToEdit = [];
            this.search = "";
            this.searchCode = null;
            this.checkedNewComposition = false;
            this.salesZone = [];
            this.ListComponentSaleZone = []
            this.ListSelectedComponent = []
            this.otherSemiElaborate = {}
            this.$emit("updateDetails", true);
        },
        locationRefresh() {
            this.$router.go(this.$router.currentRoute)
        },
        changeRequestType() {
            this.detailFormula = [];
            this.componentFormula = [];
            this.item = {};
            this.saleZone = "";
            this.stickerGloss = "";
            this.confectionRemarks = "";
            this.ListComponentSaleZone = [];
            this.bottles = 0;
            this.quality = "";
            this.brand = {};
            this.salesZone = [];
            this.preparationRemarks = "";
            this.stockPt = {};
            this.stockGb = {}
            this.stockOtherGb = {}
            this.year = "";
            this.valley = "";

            // Nuevo Producto: origen enológico activo por defecto y modo "Con mezcla comercial".
            if (this.requestType.code == 1) {
                this.checkedWineSample = true;
                this.withCommercialMix = true;
                this.npSingleVariety = null;
                this.checkedNewComposition = false;
            } else {
                this.checkedWineSample = false;
            }

            this.isTechnicalRequest = false;
            this.ptSimplifiedResults = [];
            this.selectedPtRow = null;
            this.ptSimplifiedSearchDone = false;
            this.ptSimplifiedVariety = "";
            this.ptSimplifiedSaleZone = "";

            this.ptSimplifiedFormat = "";
            this.ptSimplifiedHarvest = "";
            this.brands = [];
            this.ptVarieties = [];
            this.ptSaleZones = [];
            this.ptFormats = [];

            if (this.requestType.code == 2) this.isPt = 1;
            if (this.requestType.code == 2 || this.requestType.code == 3)
                this.getMasterItems();

            if (this.requestType.code == 1)
                this.getCommercialMix();
            this.isPt = 0;

            if (this.requestType.code != 2) {
                this.getBrands();
            }
        },
        changeSku(sku = undefined) {
            const useSimplifiedPt = this.requestType.code == 2 && !this.isTechnicalRequest;
            if (!useSimplifiedPt)
                this.saleZone = "";
            this.saleZoneYears = [];
            if (!useSimplifiedPt)
                this.year = "";
            this.detailFormula = [];
            this.componentFormula = [];
            this.ListComponentSaleZone = [];
            let cSku = this.item.code;

            if (!cSku)
                cSku = sku
            if (!cSku) {
                this.loadingPtDetail = false;
            }
            if (cSku) {
                let type = 'PT';
                if (useSimplifiedPt) {
                    if (!this.year && this.selectedPtRow && this.selectedPtRow.harvests && this.selectedPtRow.harvests.length > 0)
                        this.year = this.selectedPtRow.harvests[0];

                    if (this.year) {
                        let saleZoneAtr = "";
                        if (this.saleZone && this.saleZone.code)
                            saleZoneAtr = `&saleZone=${this.saleZone.code}`;
                        this.$store.commit("setLoading", true);
                        this.Get(this.apiUrl + `v1/formulas/getFormulasBySkuAndHarvest?sku=${cSku}&harvest=${this.year}${saleZoneAtr}`, (res) => {
                            this.detailFormula = res.data.commercialMix;
                            this.componentFormula = res.data.formulas;
                            this.ptFormulaNumber = res.data.formulaNumber;
                            this.ptFormulaHarvest = res.data.formulaHarvest;
                            this.ListSelectedComponent = [];
                            this.ListSelectedComponentToEdit = [];
                            this.componentFormula.forEach((element) => {
                                this.ListComponentSaleZone.push(element);
                                this.ListSelectedComponent.push(element);
                                this.ListSelectedComponentToEdit.push(element.c_component);
                            });
                            this.getSemiElaborateList(res.data.commercialMix.commercialMixCode);
                            this.$store.commit("setLoading", false);
                            this.loadingPtDetail = false;
                        });
                    } else {
                        this.loadingPtDetail = false;
                    }
                } else if (this.requestType.code == 2) {
                    this.saleZoneYears = [];
                    this.year = "";
                    this.$store.commit("setLoading", true);
                    this.Get(this.apiUrl + "v1/formulas/getHarvestFormulas/" + cSku, (res) => {
                        this.saleZoneYears = res.data;
                        this.$store.commit("setLoading", false);
                    });

                }
                if (this.requestType.code == 3) {
                    type = 'GB'
                    this.Get(this.apiUrl + "v1/formulas/getGBFormulas/" + cSku, (res) => {
                        this.detailFormula = res.data.semiElaborate;
                        this.componentFormula = res.data.formulas;
                        this.componentFormula.forEach((element) => {
                            this.ListComponentSaleZone.push(element);
                            // Auto-seleccionar componentes para GB
                            this.ListSelectedComponent.push({
                                "d_component": element.d_component,
                                "c_component": element.c_component,
                                "saleZone": element.saleZone,
                                "componentPosition": element.componentPosition
                            });
                            this.ListSelectedComponentToEdit.push(element.c_component);
                            // Poblar selects de insumos
                            let supplieChecked = { code: element.c_component, label: element.d_component };
                            if (element.d_material == "BOTELLA") {
                                this.bottle = supplieChecked;
                                this.disabledBottleGB = true;
                            } else if (element.d_material == "CAPSULA") {
                                this.capsule = supplieChecked;
                                this.disabledCapsuleGB = true;
                            } else if (
                                element.d_material == "CORCHO" ||
                                element.d_material == "TAPA" ||
                                element.d_material == "TAPON TECNICO"
                            ) {
                                this.capping = supplieChecked;
                                this.disabledCappingGB = true;
                            } else if (element.d_material == "CAJA") {
                                this.box = supplieChecked;
                                this.disabledBoxGB = true;
                            }
                        });
                    });
                }
                if (this.harvestToGetStock)
                    this.showStock(type, type, cSku, this.harvestToGetStock)
                else {
                    if (type === 'PT')
                        this.stockPt = {}
                    if (type === 'GB')
                        this.stockGb = {}
                }
            }

        },
        changeHarvestToSaleZone(sku = undefined) {
            this.clearFromChangeSaleZoneOrHarvest();
            let cSku = this.item.code;
            this.salesZone = [];
            this.saleZone = null;
            if (!cSku)
                cSku = sku;
            if (cSku && this.year) {
                this.salesZone = [];
                this.Get(this.apiUrl + `v1/formulas/getSaleZones?sku=${cSku}&harvest=${this.year}`, (res) => {
                    res.data.forEach((element) => {
                        this.salesZone.push({
                            code: element.code,
                            label: element.saleZone
                        });
                    });
                    this.$store.commit("setLoading", false);
                });
            }

            if (this.harvestToGetStock) {
                if (cSku) {
                    this.showStock('PT', 'PT', cSku, this.harvestToGetStock)
                }
                if (this.otherSemiElaborate.code) {
                    this.showStock('otherGb', 'otherGb', this.otherSemiElaborate.code, this.harvestToGetStock)
                }
            }
            else
                this.stockPt = {}

        },
        changeHistoricalOrUpcomig(type, sku = undefined) {
            let cSku = this.item.code;

            if (!cSku)
                cSku = sku
            if (this.harvestToGetStock) {
                if (cSku) {
                    this.showStock(type, type, cSku, this.harvestToGetStock)
                }
                if (this.otherSemiElaborate.code) {
                    this.showStock('otherGb', 'otherGb', this.otherSemiElaborate.code, this.harvestToGetStock)
                }
            }


        },
        clearFromChangeSaleZoneOrHarvest() {
            this.detailFormula = [];
            this.componentFormula = [];
            this.ListComponentSaleZone = [];
            this.ListSelectedComponent = [];
        },
        changeSaleZone() {
            this.$store.commit("setLoading", true);
            this.clearFromChangeSaleZoneOrHarvest();
            let saleZoneAtr = '';
            if (this.saleZone.code)
                saleZoneAtr = `&saleZone=${this.saleZone.code}`

            if (this.saleZone && this.year) {
                this.Get(this.apiUrl + `v1/formulas/getFormulasBySkuAndHarvest?sku=${this.item.code}&harvest=${this.year}${saleZoneAtr}`, (res) => {
                    if (this.requestType.code == 2)
                        this.detailFormula = res.data.commercialMix;
                    else if (this.requestType.code == 3) {
                        this.detailFormula = res.data.semiElaborate;
                    }
                    this.componentFormula = res.data.formulas;
                    this.componentFormula.forEach((element) => {
                        this.ListComponentSaleZone.push(element);
                    });
                    this.getSemiElaborateList(res.data.commercialMix.commercialMixCode);
                    this.$store.commit("setLoading", false);
                });
            }
            this.$store.commit("setLoading", false);

        },
        ComponentList(lc) {
            let supplieChecked = { code: lc.c_component, label: lc.d_component };
            //categories related in strighelper of api
            for (var i = 0; i < this.ListSelectedComponent.length; i++) {
                if (this.ListSelectedComponent[i].c_component === lc.c_component) {
                    this.ListSelectedComponent.splice(i, 1);
                    this.existComponent = true;
                    if (this.requestType.code == 3) {
                        if (lc.d_material == "BOTELLA") {
                            this.bottle = {};
                            this.disabledBottleGB = false;
                        } else if (lc.d_material == "CAPSULA") {
                            this.capsule = {};
                            this.disabledCapsuleGB = false;
                        } else if (
                            lc.d_material == "CORCHO" ||
                            lc.d_material == "TAPA" ||
                            lc.d_material == "TAPON TECNICO"
                        ) {
                            this.capping = {};
                            this.disabledCappingGB = false;
                        } else if (lc.d_material == "CAJA") {
                            this.box = {};
                            this.disabledBoxGB = false;
                        }
                    }
                }
            }
            if (this.existComponent == false) {
                this.ListSelectedComponent.push({
                    "d_component": lc.d_component,
                    "c_component": lc.c_component,
                    "saleZone": lc.saleZone,
                    "componentPosition": lc.componentPosition
                });
                if (this.requestType.code == 3) {
                    if (lc.d_material == "BOTELLA") {
                        this.bottle = supplieChecked;
                        this.disabledBottleGB = true;
                    } else if (lc.d_material == "CAPSULA") {
                        this.capsule = supplieChecked;
                        this.disabledCapsuleGB = true;
                    } else if (
                        lc.d_material == "CORCHO" ||
                        lc.d_material == "TAPA" ||
                        lc.d_material == "TAPON TECNICO"
                    ) {
                        this.capping = supplieChecked;
                        this.disabledCappingGB = true;
                    } else if (lc.d_material == "CAJA") {
                        this.box = supplieChecked;
                        this.disabledBoxGB = true;
                    }
                }
            }
            this.existComponent = false;
        },
        filterSKU() {
            this.$store.commit("setLoading", true);
            let isPt = false;
            if (this.requestType.code == 2)
                isPt = true;
            let data = "&Size=20&IsPt=" + isPt;
            if (this.quality)
                data += "&Quality=" + this.quality;
            if (this.brand != undefined)
                if (this.brand.label != undefined)
                    data += "&Brand=" + this.brand.label;
            this.Get(this.apiUrl + "v1/MasterItems/GetToSelect?" + data, (res) => {
                this.masterItems = []
                res.data.forEach((element) => {
                    this.masterItems.push({
                        label: element.c_sku + "  " + element.d_sku,
                        code: element.c_sku,
                        brand: element.d_family,
                        quality: element.d_sub_heading
                    });
                });
            });
            this.$store.commit("setLoading", false);
        },
        resetFilterSKU() {
            if (this.requestType.code == 2) this.isPt = 1;
            this.getMasterItems();
        },
        resetQualityFilterSKU() {
            this.quality = '';
            this.filterSKU();
        },
        resetBrandFilterSKU() {
            this.brand = '';
            this.filterSKU();
        },
        AddVariety() {
            var exist = false;
            if (
                this.percent <= 100 &&
                this.valueTotal <= 100 &&
                this.valueTotal + parseInt(this.percent) <= 100
            ) {
                if (this.listNewComposition.length > 0) {
                    this.listNewComposition.forEach((element) => {
                        if (element.variety == this.variety.label) {
                            element.percent =
                                parseInt(element.percent) + parseInt(this.percent);
                            exist = true;
                        }
                    });
                }
                if (exist == false) {
                    this.listNewComposition.push({
                        variety: this.variety.label,
                        percent: parseInt(this.percent),
                        RequestCommercialSampleDetailId: null,
                    });
                }
                this.SumTablePercent();
            } else {
                window.toastr.warning(
                    "Porcentaje de variedad y del total debe ser menor a 100 "
                );
            }
            this.resetfield();
            this.changeVarietyPercent(this.variety, this.percent);
            this.changeTable();
        },
        deleteItemMix(index) {
            this.listNewComposition.splice(index, 1);
            this.SumTablePercent();
            this.changeTable();
            this.resetfield();
            this.changeVarietyPercent(index, this.percent);
        },
        changeVarietyPercent(variety, percent) {
            if (variety != undefined && variety != "" && percent > 0)
                this.BtnAddDisabled = false;
            else this.BtnAddDisabled = true;
        },
        changeTable() {
            if (this.valueTotal == 100) this.BtnSaveDisabled = false;
            else this.BtnSaveDisabled = true;
        },
        SumTablePercent() {
            this.valueTotal = 0;
            this.listNewComposition.forEach((element) => {
                this.valueTotal = parseInt(this.valueTotal) + parseInt(element.percent);
            });
        },
        resetfield() {
            this.variety = "";
            this.percent = 0;
        },
        NoObservation() {
            this.preparationRemarks = 'Sin Observaciones';
        },
        showStockModal(type, sku, harvest) {
            this.stock = {}
            this.$store.commit("setLoading", true);
            let data = 'Sku=' + sku + '&Type=' + type
            if (harvest)
                data += '&Harvest=' + harvest
            this.Get(this.apiUrl + "v1/MasterItems/GetStock?" + data, (res) => {
                this.stock = res.data;
                this.$swal({
                    title: "Consulta de Stock",
                    html: `<table class="table table-sm table-bordered text-left">
                                <tr>
                                    <th style="width: 160px">Tipo</th>
                                    <td>`+ this.stock.materialDescription + `</td>
                                </tr>
                                <tr>
                                    <th>Sku</th>
                                    <td>`+ this.stock.sku + `</td>
                                </tr>
                                <tr>
                                    <th>Descripción</th>
                                    <td>`+ this.stock.skuDescription + `</td>
                                </tr>
                                <tr>
                                    <th>Cosecha (Año)</th>
                                    <td>`+ this.stock.harvest + `</td>
                                </tr>
                                <tr>
                                    <th>Stock</th>
                                    <td>`+ this.stock.stock + `</td>
                                </tr>
                                <tr>
                                    <th>Actualizado</th>
                                    <td>`+ this.stock.updatedStockAtString + `</td>
                                </tr>
                            </table>`,
                    icon: "info",
                    confirmButtonColor: "#3085d6",
                    width: 800
                });
            });
            this.$store.commit("setLoading", false);
        },
        showStock(type, field, sku, harvest) {
            this.stock = {}
            this.$store.commit("setLoading", true);
            let data = 'Sku=' + sku + '&Type=' + type
            if (harvest)
                data += '&Harvest=' + harvest
            this.Get(this.apiUrl + "v1/MasterItems/GetStock?" + data, (res) => {
                if (field === 'capping')
                    this.stockCapping = res.data
                if (field === 'capsule')
                    this.stockCapsule = res.data
                if (field === 'bottle')
                    this.stockBottle = res.data
                if (field === 'box')
                    this.stockBox = res.data
                if (field === 'label')
                    this.stockLabel = res.data
                if (field === 'backLabel')
                    this.stockBackLabel = res.data
                if (field === 'PT')
                    this.stockPt = res.data
                if (field === 'GB')
                    this.stockGb = res.data
                if (field === 'otherGb')
                    this.stockOtherGb = res.data
            });
            this.$store.commit("setLoading", false);
        },
        onSearchBrand(search, loading) {
            if (search.length) {
                loading(true);
                this.searchBrand(loading, search, this)
            }
        },
        onSearchValleys(search, loading) {
            if (search.length) {
                loading(true);
                this.searchValley(loading, search, this)
            }
        },
        onSearchBottle(search, loading) {
            if (search.length) {
                loading(true);
                this.searchBottle(loading, search, this)
            }
        },
        onSearchBox(search, loading) {
            if (search.length) {
                loading(true);
                this.searchBox(loading, search, this)
            }
        },
        onSearchCapping(search, loading) {
            if (search.length) {
                loading(true);
                this.searchCapping(loading, search, this)
            }
        },
        onSearchCapsule(search, loading) {
            if (search.length) {
                loading(true);
                this.searchCapsule(loading, search, this)
            }
        },
        onSearchLabel(search, loading) {
            if (search.length) {
                loading(true);
                this.searchLabel(loading, search, this)
            }
        },
        onSearchBackLabel(search, loading) {
            if (search.length) {
                loading(true);
                this.searchBackLabel(loading, search, this)
            }
        },
        onSearchMasterItem(search, loading) {
            if (search.length) {
                loading(true);
                this.searchMasterItems(loading, search, this)
            }
        },
        onSearchOtherSemiElaborate(search, loading) {
            if (search.length) {
                loading(true);
                this.searchOtherSemiElaborate(loading, search, this)
            }
        },
        searchBrand: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=10&RequestTypeId=" + vm.requestType.code;
            vm.Get(vm.apiUrl + "v1/brands?" + data, (res) => {
                vm.brands = [];
                res.data.forEach(item => {
                    vm.brands.push({
                        code: item.code,
                        label: item.label
                    });
                });
                loading(false)
            });
        }, 500),
        searchValley: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=20";
            vm.Get(vm.apiUrl + "v1/valleys?" + data, (res) => {
                vm.valleys = res.data;
                loading(false)
            });
        }, 500),
        searchBottle: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=20&Bottle=True&OnlyWithStock=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyBottles = res.data.bottles;
                loading(false)
            }, () => loading(false));
        }, 500),
        searchBox: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=20&Box=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyBoxes = res.data.boxes;
                loading(false)
            }, () => loading(false));
        }, 500),
        searchCapping: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=20&Capping=True&OnlyWithStock=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyCappingInputs = res.data.cappingInputs;
                loading(false)
            }, () => loading(false));
        }, 500),
        searchCapsule: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=20&Capsule=True&OnlyWithStock=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyCapsules = res.data.capsules;
                loading(false)
            }, () => loading(false));
        }, 500),
        searchLabel: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=20&Label=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyLabels = res.data.labels;
                loading(false)
            }, () => loading(false));
        }, 500),
        searchBackLabel: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=20&BackLabel=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyBackLabels = res.data.backLabels;
                loading(false)
            }, () => loading(false));
        }, 500),
        searchMasterItems: _.debounce((loading, search, vm) => {
            let isPt = false;
            if (vm.requestType.code == 2)
                isPt = true;
            let data = "Search=" + search + "&Size=20&IsPt=" + isPt;
            if (vm.quality)
                data += "&Quality=" + vm.quality;
            if (vm.brand != undefined)
                if (vm.brand.label != undefined)
                    data += "&Brand=" + vm.brand.label;
            vm.Get(vm.apiUrl + "v1/MasterItems/GetToSelect?" + data, (res) => {
                vm.masterItems = [];
                res.data.forEach((element) => {
                    vm.masterItems.push({
                        label: element.c_sku + "  " + element.d_sku,
                        code: element.c_sku,
                        brand: element.d_family,
                        quality: element.d_sub_heading
                    });
                });
                loading(false)
            });
        }, 500),
        searchOtherSemiElaborate: _.debounce((loading, search, vm) => {
            let isPt = false;
            let data = "Search=" + search + "&Size=40&IsPt=" + isPt;
            vm.Get(vm.apiUrl + "v1/MasterItems/GetToSelect?" + data, (res) => {
                vm.semiElaboareList = [];
                res.data.forEach((element) => {
                    vm.semiElaboareList.push({
                        label: element.c_sku + "  " + element.d_sku,
                        code: element.c_sku,
                        brand: element.d_family,
                        quality: element.d_sub_heading
                    });
                });
                loading(false)
            });
        }, 500),
    },
    computed: {
        buttonText() {
            return this.formId > 0 ? "Actualizar" : "Guardar";
        },
        titleText() {
            return this.formId > 0 ? "Editar Muestra" : "Nueva Muestra";
        },
        buttonTextNewComposition() {
            return this.formId > 0 ? "Editar Composición" : "Diseñar Composición";
        },
        bottleMessage() {
            let message = '';
            if (this.bottles <= 0)
                message = 'La cantidad de Botella debe ser mayor a 0';
            return message;
        },
        bottleSelectMessage() {
            let message = '';
            if (!this.bottle?.code)
                message = 'La Botella es Requerida';
            return message;
        },
        cappingSelectMessage() {
            let message = '';
            if (!this.capping?.code)
                message = 'La Tapa es Requerida';
            return message;
        },
        commercialMixSelectMessage() {
            let message = '';
            if (this.requestType.code === 1 && this.withCommercialMix && !(this.commercialMix && this.commercialMix.code))
                message = 'La Mezcla Comercial es Requerida';
            return message;
        },
        capsuleSelectMessage() {
            let message = '';
            if (!this.capsule?.code && this.requestType.code === 1)
                message = 'La Cápsula es Requerida';
            return message;
        },
        obsPreparationRemarksMessage() {
            let message = '';
            if (!this.preparationRemarks && this.requestType.code === 3)
                message = 'Observaciones de preparación del Vino es requerido';
            return message;
        },
        historicalOrUpcomingMessage() {
            let message = '';
            if (this.isHistoricalOrUpcoming) {
                if (!this.historicalOrUpcomingHarvest)
                    message = 'La Cosecha Histórica/Próxima es Requerida'
                else
                    if (this.historicalOrUpcomingHarvest < 1900)
                        message = 'La Cosecha Histórica/Próxima debe ser mayor o igual a 1900';
            }
            return message;
        },
        harvestToGetStock() {
            if (this.isHistoricalOrUpcoming)
                return this.historicalOrUpcomingHarvest
            return this.year
        }
    },
};
</script>

<style scoped>
.d-center {
    display: flex;
    align-items: center;
}

.pt-harvest-input {
    max-width: 95px;
}

.pt-historical-checkbox {
    white-space: nowrap;
}

/* Switches destacados "Con/Sin Mezcla Comercial" */
.mix-mode-group {
    gap: 0.75rem 0;
}

/* Amplía el espacio a la izquierda para que el switch más grande no pise el texto */
.mix-mode-switch {
    padding-left: 3.75rem;
}

.mix-mode-label {
    font-size: 1.05rem;
    font-weight: bold;
    padding-left: 0.4rem;
    line-height: 1.5rem;
}

.mix-mode-switch>>>.custom-control-label {
    cursor: pointer;
}

.mix-mode-switch>>>.custom-control-label::before {
    left: -3.75rem;
    width: 2.75rem;
    height: 1.4rem;
    border-radius: 1rem;
    top: 0.05rem;
}

.mix-mode-switch>>>.custom-control-label::after {
    left: calc(-3.75rem + 3px);
    top: calc(0.05rem + 3px);
    width: calc(1.4rem - 6px);
    height: calc(1.4rem - 6px);
    border-radius: 50%;
}

.mix-mode-switch>>>.custom-control-input:checked~.custom-control-label::after {
    transform: translateX(1.35rem);
}

.mix-mode-switch>>>.custom-control-input:checked~.custom-control-label::before {
    background-color: #007bff;
    border-color: #007bff;
}

.pt-results-table {
    max-height: 470px;
    overflow-y: auto;
}

.pt-know-sku-checkbox>>>.custom-control-input:checked~.custom-control-label::before {
    background-color: #28a745;
    border-color: #28a745;
}

.pt-know-sku-checkbox>>>.custom-control-input:checked~.custom-control-label::after {
    background-color: #fff;
}

.tasting-switch>>>.custom-control-label::before {
    width: 3.2rem;
    height: 1.8rem;
    border-radius: 1rem;
}

.tasting-switch>>>.custom-control-label::after {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    top: calc(0.25rem + 3px);
}

.tasting-switch>>>.custom-control-input:checked~.custom-control-label::after {
    transform: translateX(1.4rem);
}
</style>
